!function(e,n,t){"function"==typeof define&&define.amd?define(n,[],t):"object"==typeof module&&module.exports?module.exports=t():e[n]=t()}(this,"ulog",function(){"use strict";function e(t){return t?s[t]?s[t]:s[t]=n({name:t},e):e.debug?e:n(e)}function n(e,n,i){e.NONE=0;for(var l in f)e[l]=f[l];return Object.defineProperty(e,"level",{get:function(){return void 0!==i?i:n&&n.level},set:function(o){if(void 0===o&&n)i=void 0;else{var r=o&&(Number(o)!==Number(o)?e[o.toUpperCase()]:Number(o));r>=0&&r<=6&&(i=r)}if(t(e),!n)for(mod in s)t(s[mod])}}),t(e),e.dir=o("dir")||r,e.table=o("table")||r,e.time=o("time")||r,e.timeEnd=o("timeEnd")||r,e.assert="object"==typeof window&&o("assert")||function(){var n=[].concat.apply([],arguments);n.shift()||e.error.apply(e,n)},e}function t(n){for(var t,i=Math.max(n.name&&e.enabled(n.name)&&n.DEBUG||n.level,n.level),l=0;t=c[l];l++)n[t]=i<=l?r:o(t)||"function"==typeof print&&print||r}function o(n,t){return(t=e.con())&&(t[n]||t.log).bind(t)}function r(){}e.ulog={version:"1.1.0"},e.enable=function(e){var n,o=(e||"").split(/[\s,]+/);for(n=0;n<o.length;n++)o[n]&&(e=o[n].replace(/\*/g,".*?"),"-"===e[0]?p.push(new RegExp("^"+e.substr(1)+"$")):d.push(new RegExp("^"+e+"$")));for(n in s)t(s[n])},e.enabled=function(e){var n;for(n=0;n<p.length;n++)if(p[n].test(e))return;for(n=0;n<d.length;n++)if(d[n].test(e))return!0},e.disable=e.enable.bind(e,"");var i,l,u,a,f={ERROR:1,WARN:2,INFO:3,LOG:4,DEBUG:5,TRACE:6},c=Object.keys(f).map(function(e){return e.toLowerCase()}),s={},d=[],p=[],b=location.search.substring(1),g=b&&b.split("&");try{i=localStorage.getItem("log"),l=localStorage.getItem("debug")}catch(e){}for(u=0;a=g&&g[u]&&g[u].split("=");u++)"log"==a[0]&&(i=a[1]),"debug"==a[0]&&(l=a[1]);e.con=function(){return window.console&&console},l&&e.enable(l);var m=e();return e.level=i||e.WARN,m});
DomSearchMode = {
    OFF: 0,
    ON: 1,
    FOUND: 2
};

/**
 *
 * @property {Object}   DCMS.constructorMap Map of available Segment constructors for dom
 * @property {Object}   DCMS.templates Map of available layout templates
 * @property {Function} DCMS.siteLayout Default template which is used to render #site-container
 * @property {Function} DCMS.pageLayout Default page template which is used to render page content inside siteLayout
 * @property {Boolean}  DCMS.renderClean Global setting used when rendering siteLayout. Renders Segments without editor tools for end-user.
 * @property {Boolean}  DCMS.renderCache Global setting used when rendering siteLayout. Clears elements which should not be included into page cache.
 * @property {Boolean}  DCMS.isPage True if document is returned by PageController
 * @property {String}   DCMS.domSearchQuery  @see dom
 * @property {DomSearchMode} DCMS.domSearchMode @see dom
 * @property {Element}  DCMS.domSearchResult @see dom
 * @property {Element}  DCMS.domPopulateNamedChildrenStack @see Segment.populate
 */
DCMS = {
    cookieConsent: {
        "palette": {
            "popup": {
                "background": "rgba(0,0,0,.75)"
            },
            "button": {
                "background": "#f1d600"
            }
        },
        "content": {
            "message": yiiOptions.strings.cookieConsentMessage,
            "dismiss": yiiOptions.strings.cookieConsentDismiss,
            "link": ""
        }
    },
    constructorMap: {},
    renderClean: true,
    renderCache: false,
    templates: {},
    siteLayout: null,
    isPage: page !== false,
    domSearchMode: DomSearchMode.OFF,
    domSearchQuery: "",
    domSearchResult: null,
    domPopulateNamedChildrenStack: [],
    domScanMode: false,
    rawChildrenMap: {},
};

//region Event listener implementation
DCMS.events = {};

DCMS.addEventListener = function(name, handler) {
    if (this.events.hasOwnProperty(name))
        this.events[name].push(handler);
    else
        this.events[name] = [handler];
};

DCMS.removeEventListener = function(name, handler) {
    /* This is a bit tricky, because how would you identify functions?
       This simple solution should work if you pass THE SAME handler. */
    if (!this.events.hasOwnProperty(name))
        return;

    let index = this.events[name].indexOf(handler);
    if (index !== -1)
        this.events[name].splice(index, 1);
};

DCMS.fireEvent = function(name, args) {
    if (!this.events.hasOwnProperty(name))
        return;

    if (!args || !args.length)
        args = [];

    let evs = this.events[name], l = evs.length;
    for (let i = 0; i < l; i++) {
        evs[i].apply(null, args);
    }
};
//endregion

//region ulog - debugging tools
const log = ulog('my-module');
const noop = function(){};

log.level = log.WARN;      // ERROR [WARN] INFO LOG DEBUG TRACE
log.allowGroup = true;      // false will use regular log, I found grouping slow in firefox
log.groupCollapsed = false;  // true means groups are closed by default
log.domDebug = false;        // creates own internal log stack to reverse dom() creation tree for better readability

if(log.allowGroup) {
    if(log.groupCollapsed)
        log.group = console.groupCollapsed;
    else
        log.group = console.group;
    log.groupEnd = console.groupEnd;
} else {
    log.group = log.log;
    log.groupEnd = noop;
}

// Special logger to debug reversed JSX execution
if(log.domDebug) {
    log.domStack = [[]]; // empty stack is for logs that are before dom starts rendering
    log.earlyChildrenStack = [];

    const {error:_error, warn:_warn, log:_log, info:_info, debug:_debug, group:_group, groupEnd:_groupEnd} = log;
    log.error = function() {log.domStack[log.domStack.length-1].push(_error.bind(null, ...arguments));}
    log.warn = function() {log.domStack[log.domStack.length-1].push(_warn.bind(null, ...arguments));}
    log.log = function() {log.domStack[log.domStack.length-1].push(_log.bind(null, ...arguments));}
    log.info = function() {log.domStack[log.domStack.length-1].push(_info.bind(null, ...arguments));}
    log.debug = function() {log.domStack[log.domStack.length-1].push(_debug.bind(null, ...arguments));}
    log.group = function() {log.domStack[log.domStack.length-1].push(_group.bind(null, ...arguments));}
    log.groupEnd = function() {log.domStack[log.domStack.length-1].push(_groupEnd.bind(null, ...arguments));}

    log.printDomDebug = function() {
        log.domStack.forEach(a => {a.forEach(b => {b()})});
    }
    log.openStack = function(close) {
        //console.log("Close "+close+" previous stacks, %cOPEN A NEW ONE%c. Open before close:","color:lime;","color:inherit;", log.domStack.length);
        if(close > log.domStack.length) console.trace("now");
        let newStack = []

        if(close > 0) {
            // We move our children stacks to the new stack in reverse order (pop before concat makes it reverse, not for)
            for(let i=close; i>0; i--)
                newStack = log.domStack.pop().concat(newStack);

            // We put group start function before our children messages and all our logs will pushed to the end of the stack
            newStack.unshift(_group.bind(null, ...[...arguments].slice(1)));
        } else {
            // If we don't have children we don't move any open stacks and just push everything to the end.
            newStack.push(_group.bind(null, ...[...arguments].slice(1)));
        }

        //console.log("open new", newStack);
        log.domStack.push(newStack);
        //console.log("after close")
        //print_r(log.domStack);
    };
    log.closeStack = function () {
        //console.log("%cGROUP END","color:magenta");
        log.groupEnd();
        //print_r(log.domStack);
    }
}

/**
 * For basic debugging, can be removed when in production
 * @param arr
 * @param pre
 */
function print_r(arr,pre) {
    if(typeof pre === "undefined")
        pre = "";
    arr.forEach((e,i) => {
        const t = typeof e;
        switch(t) {
            case "function": console.log(pre+i+": "+e.name); break;
            case "object": if(e instanceof Array) {console.group("Array ("+e.length+") ["); print_r(e,pre+"\t"); console.groupEnd();} else console.log(pre+i+": [object]"); break;
            case "string":
            case "number": console.log(pre+i+": "+e); break;
        }
    })
}

const domLogCSS = "background:#cdffcd;";
const appLogCSS = "background:#cdcdff;";
const editorLogCSS = "background:#cdcdff;"; //red:ffcdcd, reminded errors
const segmentLogCSS = "background:#ffffcd;";
const toolkitLogCSS = "background:#ffe6cd;";
//endregion

/**
 * JSX DOM renderer
 * Similar to React.renderElement
 *
 * When DCMS.domSearchMode is DomSearchMode.ON then this function will search for a sub-tree matching with
 * DCMS.domSearchQuery. For now the only search query is a raw string which is compared to the 'segmentName' prop.
 * If DCMS.domSearchQuery="test" then JSX with prop segmentName="test" and it's decendants will be passed into
 * DCMS.domSearchResult variable. By default DCMS.domSearchMode is OFF, which renders whole DOM tree.
 */
function dom(element, props) {
    /*if(DCMS.domSearchMode === DomSearchMode.ON) {
        if (props != null && props.hasOwnProperty('segmentName')) {
            if(props.segmentName === DCMS.domSearchQuery) {
                DCMS.domSearchMode = DomSearchMode.FOUND;
                DCMS.domSearchResult = dom(...arguments);
            }
        }
        return;
    } else if(DCMS.domSearchMode === DomSearchMode.FOUND) {
        DCMS.domSearchMode = DomSearchMode.ON;
    }*/

    let el;
    const type = typeof element;
    if (props == null)
        props = {};

    props.children = convertChildren([...arguments].slice(2));

    if(DCMS.domScanMode && props.hasOwnProperty('rawChildren')) {
        DCMS.rawChildrenMap[props.rawChildren] = props.children;
    }

    //region DOM debugging
    let childrenCount;
    if(log.domDebug) {
        //console.log("filter1", props.children.length);
        childrenCount = (props.children.filter(function (e) {
            return e instanceof Element;//return e != null;//
        })).length;
        //console.log("filter2", props.children.length);
    }
    //endregion

    if (type === "string") {
        //region DOM debugging
        if(log.domDebug) {
            //console.log("Creating element '" + element.toUpperCase() + "'");
            let extra = [];
            if(typeof props.id !== "undefined")
                extra.push("id=\""+props.id);
            if(typeof props.className !== "undefined")
                extra.push("class=\""+props.className);
            if(extra.length) extra = extra.join('" ')+"\"";
            log.openStack(childrenCount,"%cdom[creation]: Creating element <%c"+element.toUpperCase()+" %c"+extra, domLogCSS, domLogCSS+"font-weight:bold;", domLogCSS+"font-weight:normal;color:#484;");
            log.debug("%cdom[creation]: props", domLogCSS, props);
        }
        //endregion

        el = document.createElement(element);
        el._creationProps = props;
        el._creationMethod = "string";
        el._creationName = element;
    } else if (type === "function" && element === Segment || element.prototype instanceof Segment) {
        //region DOM debugging
        //console.log("Creating Segment '" + element.name + "'");
        let earlyChildrenStack = [];
        if(log.domDebug) {
            //console.log("segment has "+childrenCount+" JSX children");
            for(let i=childrenCount; i>0; i--) {
                earlyChildrenStack = log.domStack.pop().concat(earlyChildrenStack);
                //console.log("pop earlyChildrenStack");
                //print_r(earlyChildrenStack);
            }

            //TODO internal stack + children stack, show them as two collapsables
            //console.log("add empty internalStack %cOPEN GROUP","color:lime;");
            log.domStack.push([]); //internalStack
            log.group("%cdom[creation]: Creating Segment '" + element.name + "'", domLogCSS);
            log.debug("%cdom[creation]: props", domLogCSS, props);
        }
        //endregion

        let segment = null;
        // Find existing segments by segmentName and populate their data
        if(typeof props.segmentName === "string" && props.segmentName !== "") {
            // First check for internal segments, then root segments
            for(let i=DCMS.domPopulateNamedChildrenStack.length-1; i >= 0; i--) {
                const child = DCMS.domPopulateNamedChildrenStack[i];
                if(child.name === props.segmentName) {
                    DCMS.domPopulateNamedChildrenStack.splice(i, 1);
                    return Segment.populate(child);
                }
            }

            if(!DCMS.domScanMode && typeof yiiOptions.rootSegments[props.segmentName] === "object") {
                if(yiiOptions.rootSegments[props.segmentName] instanceof Segment) {
                    segment = yiiOptions.rootSegments[props.segmentName];
                } else {
                    // TODO name scan when AutoSegment
                    // how to populate children?
                    // if container then
                    // ALSO TODO: if container is empty then check for JSX chilrens, prob needs name for scan
                    return Segment.populate(yiiOptions.rootSegments[props.segmentName]);
                }
            }
        }

        // Or create a new one
        if(segment == null) segment = new element(props);
        el = segment.render();

        //TODO: kus ma neid kasutan?
        el._creationProps = props;
        el._creationMethod = "Segment";
        el._creationName = element.name;

        //console.log("segment has "+props.children.length+" children"+(props.children.length?", lets pop them out":", nothing to take"));
        // Remove other props as Segments should handle props by themselves internally (in html render)
        props = {children: props.children};

        //region DOM debugging
        if(log.domDebug) {
            // For the following JSX "<article><section><RichText><ul><li></li></ul></RichText></section></article>"
            // execution order of dom() is "|li ul RichText div| section article". Stacks between '||' markings are
            // related to the RichText segment which creates div in html() and appends JSX outer children (ul and li)
            // later into the internal div. So RichText log stacks are following:
            // "earlyChildrenStack[li, ul] internalStack[RichText] lateChildrenStack[div]"

            //console.log("before internal pops");
            //print_r(log.domStack);

            // TODO uuri seda miks siin children count on 0 kuigi segmendi alguses ütleb 1
            //console.log("segment has "+props.children.length+" children"+(props.children.length?", lets pop them out":", nothing to take"));
            //for(let i=segment.props.children.length-1; i>=0; i--) {
            //    console.log(segment.props.children[i]);
            //}

            let tempStack;
            let lateChildrenStack = [];
            //if(childrenCount > 0) {
            //TODO: checki kui segment html ei returni midagi või null returnib, mis siis juhtub
            //console.log("lateChildrenStack.pop %cTAKE OUT", "color:orange");
            lateChildrenStack = log.domStack.pop();
            //}

            //console.log("segment has actually "+lateChildrenStack.length+" children in lateChildrenStack");

            //console.log("early Children Stack",earlyChildrenStack.length);
            //print_r(earlyChildrenStack);
            //console.log("late children stack",lateChildrenStack.length);
            //print_r(lateChildrenStack);


            log.openStack(0,"%cdom[creation]: Segment internals", domLogCSS);
            tempStack = log.domStack.pop();
            log.domStack.push(tempStack.concat(lateChildrenStack));
            log.closeStack();
            lateChildrenStack = log.domStack.pop();

            if(earlyChildrenStack.length) {
                log.openStack(0,"%cdom[creation]: Segment children", domLogCSS);
                tempStack = log.domStack.pop();
                log.domStack.push(tempStack.concat(earlyChildrenStack));
                log.closeStack();
                earlyChildrenStack = log.domStack.pop();
            }


            //console.log("early Children Stack",earlyChildrenStack.length);
            //print_r(earlyChildrenStack);
            //console.log("late children stack",lateChildrenStack.length);
            //print_r(lateChildrenStack);


            //console.log("after internal pops");
            //print_r(log.domStack);


            /* I can't do injection because there is no clean way to detect multi-level Segment's children drop point.
               Instead I group them into "internals" and "children" subcategories, it should be even more convenient.
            // Search for the first groupEnd so we can inject children stacks before it
            let inject = lateChildrenStack.length-1;
            for(let i=0,lc; lc=lateChildrenStack[i]; i++) {
                //console.log(lc.name, lc.name.indexOf("groupEnd") !== -1);
                if(lc.name.indexOf("groupEnd") !== -1) {
                    //console.log(lc.name+ " is also the inject element with index:",i);
                    inject = i;
                    break;
                }
            }
            lateChildrenStack.splice(inject, 0,...earlyChildrenStack);*/

            //console.log("internalStack.pop %cCLOSE GROUP","color:red");
            let internalStack = log.domStack.pop();
            //console.log("REMOVED empty stack first");
            // When JSX had children for Segment, but Segment is not using them in html, then we can see it in
            // internal stack. Just remove empty stacks of late children.
            //console.log("childrenCount",childrenCount);
            //while(childrenCount > 0 && internalStack.length === 0) {
            while(internalStack.length === 0) {
                internalStack = log.domStack.pop();
                //console.log("REMOVED empty stack");
            }
            //internalStack.unshift()

            //console.log("pop internalStack, length:",internalStack.length);
            //print_r(internalStack);
            log.domStack.push(internalStack.concat(lateChildrenStack, earlyChildrenStack));
            //console.log("domStack after late + internal %cPUT BACK IN", "color:orange")
            //print_r(log.domStack);
        }
        //endregion
    } else if (type === "function") {
        //region DOM debugging
        if(log.domDebug) {
            //console.log("f %cOPEN GROUP","color:lime;");
            log.domStack.push([]); //internalStack
            log.group("%cdom[creation]: Creating from function '" + element.name + "'", domLogCSS);
            log.debug("%cdom[creation]: props", domLogCSS, props);
        }
        //endregion

        el = element(props);
        el._creationProps = props;
        el._creationMethod = "function";
        el._creationName = element.name;

        //region DOM debugging
        if(log.domDebug) {
            const lateChildrenStack = log.domStack.pop();
            const internalStack = log.domStack.pop();
            log.domStack.push(internalStack.concat(lateChildrenStack));
        }
        //endregion
    } else {
        console.error(`Error creating element from a custom type in JSX. Type '${element.name}' is not defined.`);
        return;
    }

    // Add props to the element
    if (props) {
        //log.debug("%cdom[props]: Adding props to the element", domLogCSS);
        if(typeof props.classList !== "undefined") {
            props.className = props.classList.toString();
            if(props.className.length === 0)
                delete props.className;
        }

        Object.keys(props).forEach(propName => {
            if (propName === "children" || propName === "classList") return;
            if (propName in el) {
                el[propName] = props[propName];
            } else if (propName === "bindInto") {
                props[propName].element = el;
            } else if (propName.match(/^on[A-Z]/) != null) {
                if (typeof props[propName] === "function")
                    el[propName.toLowerCase()] = props[propName];
                else
                    el[propName] = props[propName];
            } else if(propName.match(/^data[A-Z]/)) {
                el.dataset[propName.charAt(4).toLowerCase() + propName.substring(5)] = props[propName];
            } else if (propName.match(/^aria-/) != null || propName === "role") {
                el.setAttribute(propName, props[propName]);
            } else if (propName === "class") {
                log.error("JSX error: Use 'className' instead of 'class'")
            }
        })
    }

    // Append children
    if(typeof props.children !== "undefined") {
        //log.debug("%cdom[children]: Appending children to the element", domLogCSS);
        props.children.forEach(function (child) {
            if (typeof child !== "undefined" && child != null){
                // Segments may have multi-level structure, so children must be added using Segment internal method
                if(el.isSegment())
                    el.segment.appendChild(child);
                else
                    el.appendChild(child);
            }
        });
    }

    //Logging related
    if(log.domDebug) log.closeStack();

    return el;

    /**
     * Christian function
     * @see Jesus
     * @param {*} badKids 
     */
    function convertChildren(badKids) {
        let children = [];
        for (let i = 0; i < badKids.length; i++) {
            const argType = typeof badKids[i];
            if (argType === "object" && badKids[i] instanceof Node) {
                children.push(badKids[i]);
            } else if (argType === "object" && badKids[i] instanceof Array) {
                children = children.concat(convertChildren(badKids[i]));
            } else if (argType === "function") {
                children.push(badKids[i]());
            } else if (argType === "string" && badKids[i].substring(0, 1) === "<") {
                try {
                    const temp = document.createElement("div");
                    temp.innerHTML = badKids[i];
                    children = [...children, ...temp.children]; // I did performance test on this, spreads were fastest
                } catch (err) {
                    console.error(err);
                }
            } else if (argType !== "undefined" && badKids[i] != null) {
                children.push(document.createTextNode(htmlDecode(badKids[i])));
            }
        }
        return children;
    }
}
/**
 * This class is used as Singleton, initialization is done in zcms.js
 * Access ContextMenu from DCMS.contextMenu in window scope
 *
 * @return ContextMenu
 */
let ContextMenu = function() {
    let _this = this
    
    this.open = function(pos, items) {
        closeContextMenu(null, true)
        openMenu(pos, items)
    }
    
    function openMenu(pos, items) {
        let container = document.createElement('div')
        let ul = document.createElement('ul')
        container.id = "context-menu"
        
        for(let i = 0, item; item = items[i]; i++) {
            let li = document.createElement('li')
            let span = document.createElement('span')
            span.textContent = " "+item.text
            
            if(item.icon !== undefined && item.icon.length) {
                let faIcon = document.createElement('i')
                faIcon.className = item.icon;
                li.appendChild(faIcon)
            }
            
            li.appendChild(span)
            if(typeof item.callback === "function") {
                li.addEventListener("click", function(e) {
                    item.callback()
                    closeContextMenu(e, true)
                })
            }
            ul.appendChild(li)
        }
        
        container.style.top =  pos.y + 'px';
        container.style.left = pos.x + 'px';
        container.style.position = "fixed";
        container.appendChild(ul)
        
        document.body.appendChild(container)
    }
    
}

function closeContextMenu(e, forceClose) {
    let contextMenuRooDiv = document.getElementById("context-menu")
    if(contextMenuRooDiv !== null && contextMenuRooDiv !== 'undefined') {
        const box = getBetterBoundingRect(contextMenuRooDiv)
        if(typeof forceClose !== 'undefined' || !(e.clientX > box.left && e.clientX < box.right && e.clientY > box.top && e.clientY < box.bottom)) {
            contextMenuRooDiv.parentElement.removeChild(contextMenuRooDiv)
        }   
    }
}

ContextMenu = new ContextMenu()
window.addEventListener('mousedown', closeContextMenu)
!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){var i=/{{([a-z][a-z0-9\-_]*)}}/gi;return e.replace(i,function(e){return t(arguments[1])||""})},getCookie:function(e){var t="; "+document.cookie,i=t.split("; "+e+"=");return 2!=i.length?void 0:i.pop().split(";").shift()},setCookie:function(e,t,i,n,o){var s=new Date;s.setDate(s.getDate()+(i||365));var r=[e+"="+t,"expires="+s.toUTCString(),"path="+(o||"/")];n&&r.push("domain="+n),document.cookie=r.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n,o=0;if(0===e.length)return o;for(t=0,n=e.length;t<n;++t)i=e.charCodeAt(t),o=(o<<5)-o+i,o|=0;return o},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){e=this.normaliseHex(e);var t=parseInt(e.substr(0,2),16),i=parseInt(e.substr(2,2),16),n=parseInt(e.substr(4,2),16),o=(299*t+587*i+114*n)/1e3;return o>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38,n=(t>>16)+i,o=(t>>8&255)+i,s=(255&t)+i,r=(16777216+65536*(n<255?n<1?0:n:255)+256*(o<255?o<1?0:o:255)+(s<255?s<1?0:s:255)).toString(16).slice(1);return"#"+r},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&"undefined"!=typeof e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){function n(){this.initialise.apply(this,arguments)}function o(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function s(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function r(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;return o&&t(n),o}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(){var e=this.options,i="top"==e.position||"bottom"==e.position?"banner":"floating";t.isMobile()&&(i="floating");var n=["cc-"+i,"cc-type-"+e.type,"cc-theme-"+e.theme];e["static"]&&n.push("cc-static"),n.push.apply(n,a.call(this));p.call(this,this.options.palette);return this.customStyleSelector&&n.push(this.customStyleSelector),n}function l(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message),Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info),e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];return o||(o=i.layouts.basic),t.interpolateString(o,function(t){return e[t]})}function u(i){var n=this.options,o=document.createElement("div"),s=n.container&&1===n.container.nodeType?n.container:document.body;o.innerHTML=i;var r=o.children[0];return r.style.display="none",t.hasClass(r,"cc-window")&&e.hasTransition&&t.addClass(r,"cc-invisible"),this.onButtonClick=h.bind(this),r.addEventListener("click",this.onButtonClick),n.autoAttach&&(s.firstChild?s.insertBefore(r,s.firstChild):s.appendChild(r)),r}function h(n){var o=n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0)),t.hasClass(o,"cc-revoke")&&this.revokeChoice()}function p(e){var i=t.hash(JSON.stringify(e)),n="cc-color-override-"+i,o=t.isPlainObject(e);return this.customStyleSelector=o?n:null,o&&d(i,e,"."+n),o}function d(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+v(a.background)]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var l=document.createElement("style");document.head.appendChild(l),e.customStyles[i]={references:1,element:l.sheet};var u=-1;for(var h in s)s.hasOwnProperty(h)&&l.sheet.insertRule(h+"{"+s[h].join(";")+"}",++u)}function v(e){return e=t.normaliseHex(e),"000000"==e?"#222":t.getLuminance(e)}function f(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}function m(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}function b(){var t=this.setStatus.bind(this),i=this.options.dismissOnTimeout;"number"==typeof i&&i>=0&&(this.dismissTimeout=window.setTimeout(function(){t(e.status.dismiss)},Math.floor(i)));var n=this.options.dismissOnScroll;if("number"==typeof n&&n>=0){var o=function(i){window.pageYOffset>Math.floor(n)&&(t(e.status.dismiss),window.removeEventListener("scroll",o),this.onWindowScroll=null)};this.onWindowScroll=o,window.addEventListener("scroll",o)}}function y(){if("info"!=this.options.type&&(this.options.revokable=!0),t.isMobile()&&(this.options.animateRevokable=!1),this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" "));this.revokeBtn=u.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=20,s=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<o&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>s&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}var g={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"http://cookiesandyou.com",close:"&#x274c;"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',revokeBtn:'<div class="cc-revoke {{classes}}">Cookie Policy</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{dismiss}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{dismiss}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block","static":!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};return n.prototype.initialise=function(e){this.options&&this.destroy(),t.deepExtend(this.options={},g),t.isPlainObject(e)&&t.deepExtend(this.options,e),r.call(this)&&(this.options.enabled=!1),m(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),m(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var i=this.options.window.replace("{{classes}}",c.call(this).join(" ")).replace("{{children}}",l.call(this)),n=this.options.overrideHTML;if("string"==typeof n&&n.length&&(i=n),this.options["static"]){var o=u.call(this,'<div class="cc-grower">'+i+"</div>");o.style.display="",this.element=o.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=u.call(this,i);b.call(this),y.call(this),this.options.autoOpen&&this.autoOpen()},n.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,f(this.options.palette),this.options=null},n.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},n.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},n.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&s.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options["static"]){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}var r=20;this.openingTimeout=setTimeout(o.bind(this,i),r)}},n.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),o.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options["static"]&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=s.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},n.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},n.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},n.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},n.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},n.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},n.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled&&this.open()},n.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},n.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},n.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},n}(),e.Location=function(){function e(e){t.deepExtend(this.options={},s),t.isPlainObject(e)&&t.deepExtend(this.options,e),this.currentServiceIndex=-1}function i(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function n(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("X-Requested-With","XMLHttpRequest"),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function o(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}var s={timeout:5e3,services:["freegeoip","ipinfo","maxmind"],serviceDefinitions:{freegeoip:function(){return{url:"//freegeoip.net/json/?callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country_code}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?o({error:i.statusMessage}):{code:i.countryCode}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){return window.geoip2?void geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(i){e(o(i))}},function(t){e(o(t))}):void e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};return e.prototype.getNextService=function(){var e;do e=this.getServiceByIdx(++this.currentServiceIndex);while(this.currentServiceIndex<this.options.services.length&&!e);return e},e.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},e.prototype.locate=function(e,t){var i=this.getNextService();return i?(this.callbackComplete=e,this.callbackError=t,void this.runService(i,this.runNextServiceOnError.bind(this))):void t(new Error("No services to run"))},e.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},e.prototype.runService=function(e,t){var o=this;if(e&&e.url&&e.callback){var s=e.isScript?i:n,r=this.setupUrl(e);s(r,function(i){var n=i?i.responseText:"";e.__JSONP_DATA&&(n=e.__JSONP_DATA,delete e.__JSONP_DATA),o.runServiceCallback.call(o,t,e,n)},this.options.timeout,e.data,e.headers)}},e.prototype.runServiceCallback=function(e,t,i){var n=this,o=function(t){s||n.onServiceResult.call(n,e,t)},s=t.callback(o,i);s&&this.onServiceResult.call(this,e,s)},e.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},e.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},e.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},e.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},e.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.error("The service["+t+"] ("+i.url+") responded with the following error",e)},e}(),e.Law=function(){function e(e){this.initialise.apply(this,arguments)}var i={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","SI","ES","SE","GB","UK"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};return e.prototype.initialise=function(e){t.deepExtend(this.options={},i),t.isPlainObject(e)&&t.deepExtend(this.options,e)},e.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},e.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},e}(),e.initialise=function(t,i,n){var o=new e.Law(t.law);i||(i=function(){}),n||(n=function(){}),e.getCountryCode(t,function(n){delete t.law,delete t.location,n.code&&(t=o.applyLaw(t,n.code)),i(new e.Popup(t))},function(i){delete t.law,delete t.location,n(i,new e.Popup(t))})},e.getCountryCode=function(t,i,n){if(t.law&&t.law.countryCode)return void i({code:t.law.countryCode});if(t.location){var o=new e.Location(t.location);return void o.locate(function(e){i(e||{})},n)}i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});
/**
 * Dummy for yiiOptions
 * @name yiiOptions
 * @class
 * @property {String}  name
 * @property {String}  language
 * @property {Object}  strings
 * @property {Number}  phpUploadLimit
 * @property {Array}   flashMessages
 * @property {Array}   siteNav
 * @property {Object}  uploadFolder
 * @property {Array}   rootSegments
 * @property {Array}   globalFields
 * @property {Boolean} isEditor
 * @property {Boolean} isDebug
 */

/**
 * Dummy for page
 * @name page
 * @class
 * @property {Number} id
 * @property {String} title
 * @property {String} layout
 * @property {String} content_class
 * @property {String} content_id
 * @property {Boolean} isCached
 * @property {Segment|null} rootSegment
 */

//region Keyboard and click helper
const longPressLenght = 600 /*ms*/ ,
    longPressMoveThreshold = 8 /*px*/ ;
let longPressTimer = null,
    longPressPosition = {
        x: 0,
        y: 0
    };

window.addEventListener('keydown', onGlobalKeyDown)
window.addEventListener('keyup', onGlobalKeyUp)
document.body.addEventListener('mousedown', onGlobalMouseDown)
window.addEventListener('mousemove', onGlobalMouseMove)
document.body.addEventListener('mouseup', onGlobalMouseUp)

function onGlobalKeyDown(e) {
    let key
    if (window.event) {
        key = window.event.keyCode
        window.isShiftModifier = !!window.event.shiftKey // typecast to boolean
        window.isAltModifier = !!window.event.altKey
        window.isCtrlModifier = !!window.event.metaKey || !!window.event.ctrlKey
        window.isSpaceModifier = key === 32
    } else {
        key = e.which
        window.isShiftModifier = !!e.shiftKey
        window.isAltModifier = !!e.altKey
        window.isCtrlModifier = !!e.metaKey || !!e.ctrlKey
        window.isSpaceModifier = key === 32
    }
}

function onGlobalKeyUp(e) {
    let key
    if (window.event) {
        key = window.event.keyCode
        window.isShiftModifier = !!window.event.shiftKey // typecast to boolean
        window.isAltModifier = !!window.event.altKey
        window.isCtrlModifier = !!window.event.metaKey || !!window.event.ctrlKey
        window.isSpaceModifier = key === 32
    } else {
        key = e.which
        window.isShiftModifier = !!e.shiftKey
        window.isAltModifier = !!e.altKey
        window.isCtrlModifier = !!e.metaKey || !!e.ctrlKey
        window.isSpaceModifier = key === 32
    }
}

function onLongHold(e) {
    longPressTimer = null;
    // If mouse didn't move during hold
    const a = e.clientX - longPressPosition.x;
    const b = e.clientY - longPressPosition.y;
    if (Math.sqrt(a * a + b * b) < longPressMoveThreshold) {
        e.target.dispatchEvent(new MouseEvent("mousehold", e));
    }
}

function onGlobalMouseDown(e) {
    if (!longPressTimer) {
        longPressPosition.x = e.clientX;
        longPressPosition.y = e.clientY;
        longPressTimer = setTimeout(onLongHold.bind(this, e), longPressLenght);
    }
}

function onGlobalMouseMove(e) {
    if (longPressTimer) {
        longPressPosition.x = e.clientX;
        longPressPosition.y = e.clientY;
    }
}

function onGlobalMouseUp(e) {
    if (longPressTimer) {
        clearTimeout(longPressTimer);
        longPressTimer = null;
    } else {
        // If mouse didn't move during hold
        const a = e.clientX - longPressPosition.x;
        const b = e.clientY - longPressPosition.y;
        if (Math.sqrt(a * a + b * b) < longPressMoveThreshold) {
            e.target.dispatchEvent(new MouseEvent("longclick", e));
        }
    }
}
//endregion

//region Network helpers
function get(url) {
    return new Promise(function (resolve, reject) {
        const req = new XMLHttpRequest();
        req.open('GET', url);

        req.onload = requestOnLoad.bind(req, resolve, reject);
        req.onerror = function () {
            reject(new Error(yiiOptions.strings.networkError));
        };

        req.send();
    });
}

function post(url, data, contentType) {
    return new Promise(function (resolve, reject) {
        const req = new XMLHttpRequest();
        req.open('POST', url);
        if (typeof contentType !== "undefined")
            req.setRequestHeader("Content-Type", contentType);
        req.setRequestHeader('X-CSRF-Token', yii.getCsrfToken());

        req.onload = requestOnLoad.bind(req, resolve, reject);
        req.onerror = function () {
            reject(new Error(yiiOptions.strings.networkError));
        };

        req.send(data);
    });
}

function getJSON(url) {
    return get(url).then(JSON.parse);
}

function postJSON(url, data) {
    return post(url, JSON.stringify(data, getCircularReplacer()), "application/json").then(JSON.parse);
}

function requestOnLoad(resolve, reject) {
    if (this.status == 200) {
        resolve(this.response);
    } else {
        try {
            // Look for controller returned errors
            let json = JSON.parse(this.response);

            if (this.status >= 400 && this.status < 500) {
                // Probably an user error
                if (typeof json.errors !== "undefined")
                    Notifier.showAll(json.errors, "danger");
                else if (typeof json.message !== "undefined") {
                    Notifier.showError(json.message);
                }
            } else {
                // Probably a server error
                if (yiiOptions.isDebug) {
                    if (typeof json.errors !== "undefined")
                        Notifier.showAll(json.errors, "danger");
                    else if (typeof json.message !== "undefined") {
                        Notifier.showError(json.message);
                    }
                }
                //TODO send error to the server
                console.error(json);
                reject(new Error(yiiOptions.strings.errorSave));
            }
        } catch (err) {
            //TODO send error to the server
            console.error(err);
            reject(new Error(yiiOptions.strings.errorSave));
        }
    }
}

const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

const reflect = p => p.then(v => ({
        v,
        status: "fulfilled"
    }),
    e => ({
        e,
        status: "rejected"
    }));
//endregion

/**
 *	Takes HTML checkbox input as an argument and turns it into styled one
 */
function upgradeCheckbox(elem) {
    let label = document.createElement('label')
    label.className = "cbox"

    //Find label text and insert it into container
    if (elem.id !== "") {
        let oldLabel = document.querySelector("label[for='" + elem.id + "']")
        if (oldLabel !== null) {
            let text = document.createTextNode(oldLabel.textContent)
            label.appendChild(text)
            oldLabel.parentNode.removeChild(oldLabel)
        }
    }

    //Put container around current input
    elem.classList.remove('cbox')
    elem.parentNode.insertBefore(label, elem)
    elem.parentNode.removeChild(elem)
    label.appendChild(elem)

    //Add checkmark
    let tick = document.createElement('span')
    tick.className = "checkmark"
    label.appendChild(tick)
}

var initPhotoSwipeFromDOM = function (gallerySelector) {

    var parseThumbnailElements = function (el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            childElements,
            thumbnailEl,
            size,
            item;

        for (var i = 0; i < numNodes; i++) {
            el = thumbElements[i];

            // include only element nodes
            if (el.nodeType !== 1) {
                continue;
            }

            childElements = el.children;

            size = el.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: el.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10),
                //author: el.getAttribute('data-author')
            };

            item.el = el; // save link to element for getThumbBoundsFn

            if (childElements.length > 0) {
                item.msrc = childElements[0].getAttribute('src'); // thumbnail url
                if (childElements.length > 1) {
                    item.title = childElements[1].innerHTML; // caption (contents of figure)
                }
            }


            var mediumSrc = el.getAttribute('data-med');
            if (mediumSrc) {
                size = el.getAttribute('data-med-size').split('x');
                // "medium-sized" image
                item.m = {
                    src: mediumSrc,
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };
            }
            // original image
            item.o = {
                src: item.src,
                w: item.w,
                h: item.h
            };

            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        var clickedListItem = closest(eTarget, function (el) {
            return el.tagName === 'A';
        });

        if (!clickedListItem) {
            return;
        }

        var clickedGallery = clickedListItem.parentNode;

        var childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
                continue;
            }

            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }

        if (index >= 0) {
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };

    var photoswipeParseHash = function () {
        var hash = window.location.hash.substring(1),
            params = {};

        if (hash.length < 5) { // pid=1
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function (index) {
                // See Options->getThumbBoundsFn section of docs for more info
                var thumbnail = items[index].el.children[0],
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return {
                    x: rect.left,
                    y: rect.top + pageYScroll,
                    w: rect.width
                };
            },

            /*addCaptionHTMLFn: function(item, captionEl, isFake) {
                if(!item.title) {
                    captionEl.children[0].innerText = '';
                    return false;
                }
                captionEl.children[0].innerHTML = item.title +  '<br/><small>Photo: ' + item.author + '</small>';
                return true;
            },*/

        };


        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for (var j = 0; j < items.length; j++) {
                    if (items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
            return;
        }



        var radios = document.getElementsByName('gallery-style');
        for (var i = 0, length = radios.length; i < length; i++) {
            if (radios[i].checked) {
                if (radios[i].id == 'radio-all-controls') {

                } else if (radios[i].id == 'radio-minimal-black') {
                    options.mainClass = 'pswp--minimal--dark';
                    options.barsSize = {
                        top: 0,
                        bottom: 0
                    };
                    options.captionEl = false;
                    options.fullscreenEl = false;
                    options.shareEl = false;
                    options.bgOpacity = 0.85;
                    options.tapToClose = true;
                    options.tapToToggleControls = false;
                }
                break;
            }
        }

        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        // see: http://photoswipe.com/documentation/responsive-images.html
        var realViewportWidth,
            useLargeImages = false,
            firstResize = true,
            imageSrcWillChange;

        gallery.listen('beforeResize', function () {

            var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
            dpiRatio = Math.min(dpiRatio, 2.5);
            realViewportWidth = gallery.viewportSize.x * dpiRatio;


            if (realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200) {
                if (!useLargeImages) {
                    useLargeImages = true;
                    imageSrcWillChange = true;
                }

            } else {
                if (useLargeImages) {
                    useLargeImages = false;
                    imageSrcWillChange = true;
                }
            }

            if (imageSrcWillChange && !firstResize) {
                gallery.invalidateCurrItems();
            }

            if (firstResize) {
                firstResize = false;
            }

            imageSrcWillChange = false;

        });

        gallery.listen('gettingData', function (index, item) {
            if (useLargeImages) {
                item.src = item.o.src;
                item.w = item.o.w;
                item.h = item.o.h;
            } else {
                item.src = item.m.src;
                item.w = item.m.w;
                item.h = item.m.h;
            }
        });

        gallery.init();
    };

    // select all gallery elements
    var galleryElements = document.querySelectorAll(gallerySelector);
    for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
};

//region Helpers
/**
 * Will take translated string from yiiOptions.strings and will replace message params when available
 * @param {String} name Name of the string
 * @param {Object} [params] Object of key value pairs of message parameters eg {file: fileName, formattedLimit: size+"kB"}
 * @returns string
 */
function translate(name, params) {
    let string = yiiOptions.strings[name]
    if (typeof params !== "undefined") {
        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                const pattern = new RegExp('{' + key + '}', 'g')
                string = string.replace(pattern, params[key])
            }
        }
    }
    return string
}

function GetIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./))
        return 11;

    else
        return 0; //It is not IE
}

function getBetterBoundingRect(element) {
    let rect = element.getBoundingClientRect();
    // as boundingClientRect returns readonly object
    return {
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
        top: rect.y,
        middle: (rect.y + rect.height / 2),
        bottom: (rect.y + rect.height),
        left: rect.x,
        center: (rect.x + rect.width / 2),
        right: (rect.x + rect.width)
    };
}

BetterBoundingRect = function (element) {
    this.updateRect(element);
}
BetterBoundingRect.prototype.isInBounds = function (x, y) {
    return y > this.top && y < this.bottom && x > this.left && x < this.right;
}
BetterBoundingRect.prototype.inDiagonalSector = function (x, y) {
    const d = (y - this.top) > this.height / this.width * (x - this.left); //above downward slope
    const u = (y - this.top) > this.height / this.width * (x - this.left) * -1 + this.height; //above upward slope
    return d ^ u + d + d;
}
BetterBoundingRect.prototype.updateRect = function (element) {
    const rect = element.getBoundingClientRect();
    this.x = rect.x;
    this.y = rect.y;
    this.width = rect.width;
    this.height = rect.height;
    this.top = rect.y;
    this.middle = (rect.y + rect.height / 2);
    this.bottom = (rect.y + rect.height);
    this.left = rect.x;
    this.center = (rect.x + rect.width / 2);
    this.right = (rect.x + rect.width);
    return this;
}

/**
 * Convert bytes into human readable format
 * @param {Number} bytes
 * @param {Boolean} si use SI system
 * @returns {string}
 */
function humanFileSize(bytes, si) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = si ?
        ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] :
        ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
}

/**
 * Add a stylesheet rule to the document (it may be better practice
 * to dynamically change classes, so style information can be kept in
 * genuine stylesheets and avoid adding extra elements to the DOM).
 * Note that an array is needed for declarations and rules since ECMAScript does
 * not guarantee a predictable object iteration order, and since CSS is
 * order-dependent.
 * @param {Array} rules Accepts an array of JSON-encoded declarations
 * @param {string} name Name is used to avoid duplicate insertions. You can add duplicate by omitting name.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/insertRule
 * @example
 addStylesheetRules([
 ['h2', // Also accepts a second argument as an array of arrays instead
   ['color', 'red'],
   ['background-color', 'green', true] // 'true' for !important rules
 ],
 ['.myClass',
   ['background-color', 'yellow']
 ]
 ]);
 */
let extraStylesheet = null
let extraStylesheetMap = [];

function addStylesheetRules(rules, name) {
    if (typeof name !== "undefined") {
        if (extraStylesheetMap.indexOf(name) !== -1) return;
        extraStylesheetMap.push(name);
    }
    if (extraStylesheet === null) {
        let style = document.createElement('style');
        document.head.appendChild(style);
        extraStylesheet = style.sheet;
    }

    for (let i = 0; i < rules.length; i++) {
        let j = 1,
            rule = rules[i],
            selector = rule[0],
            propStr = '';
        // If the second argument of a rule is an array of arrays, correct our variables.
        if (Array.isArray(rule[1][0])) {
            rule = rule[1];
            j = 0;
        }

        for (let pl = rule.length; j < pl; j++) {
            let prop = rule[j];
            propStr += prop[0] + ': ' + prop[1] + (prop[2] ? ' !important' : '') + ';\n';
        }

        // Insert CSS Rule
        extraStylesheet.insertRule(selector + '{' + propStr + '}', extraStylesheet.cssRules.length);
    }
}

/**
 * Add a stylesheet rule to the document.
 * @param {string} rule Raw CSS string
 * @param {string} name Name is used to avoid duplicate insertions. You can add duplicate by omitting name.
 */
function addStylesheetString(rule, name) {
    if (typeof name !== "undefined") {
        if (extraStylesheetMap.indexOf(name) !== -1) return;
        extraStylesheetMap.push(name);
    }
    if (extraStylesheet === null) {
        let style = document.createElement('style');
        document.head.appendChild(style);
        extraStylesheet = style.sheet;
    }
    extraStylesheet.insertRule(rule, extraStylesheet.cssRules.length);
}

function createSelectElement(options) {
    let select = document.createElement('select');
    options.forEach(o => {
        let option = document.createElement('option');
        option.innerHTML = o.name;
        option.value = o.value;
        if (typeof o.selected !== "undefined")
            option.selected = o.selected;
        select.appendChild(option);
    })
    return select;
}

const objectWithoutKey = (object, key) => {
    const {
        [key]: deletedKey, ...otherKeys
    } = object;
    return otherKeys;
}

/**
 * Returns random placeholder text. You can configure length by passing a number and selector string.
 *
 * Avalable selectors are: char, word, title, sentence, paragraph. You can write only first letter of selector.
 * Default selector is sentence, so passing getPlaceholderText(2) will get you two sentences.
 * Title selector will remove any symbols and limits word count randomly from 3 to 8.
 *
 * Output has upper limit when using char, word, title or sentence.
 *
 * Parameter order is interchangeable as long as one is number type and another is string type.
 *
 * Examples:
 * getPlaceholderText("word") "Lorem"
 * getPlaceholderText("w",2) "Lorem ipsum"
 * getPlaceholderText(2,"w") "Lorem ipsum"
 * getPlaceholderText("sentence") "Sed feugiat pellentesque nisi ut posuere."
 * getPlaceholderText() "Sed feugiat pellentesque nisi ut posuere."
 * getPlaceholderText(2,"char") "Lo"
 * getPlaceholderText("title") "Lorem ipsum dolor sit amet consectetur"
 *
 * @param {number|string} [count]
 * @param {string|number} [selector]
 * @param {string} [paragraphSeparator]
 * @return {string}
 */
function getPlaceholderText(count, selector, paragraphSeparator) {
    const countType = typeof count;
    const selectorType = typeof selector;
    if (countType === "string" && selectorType === "string") count = parseInt(count);
    if (countType === "string" && selectorType === "number") {
        const a = count;
        count = selector;
        selector = a;
    }
    if (selectorType === "undefined" && countType === "string") {
        selector = count;
        count = 1;
    }
    if (countType === "undefined") count = 1;
    if (typeof paragraphSeparator === "undefined") paragraphSeparator = "\n";
    count = Math.round(count);

    const paragraphs = [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "Donec lacinia porttitor fermentum. Sed elementum venenatis varius. Aliquam condimentum erat erat, eu ultricies elit sodales convallis. Curabitur congue nulla quis dignissim iaculis. Integer ac diam maximus purus mattis imperdiet at et quam. Nunc semper velit sapien. Suspendisse pellentesque nisl sapien, ac vulputate est lacinia et. Mauris eu enim id tellus vulputate euismod. Aliquam erat volutpat. Sed vehicula quis ipsum in fringilla. In ut mi sed mi pulvinar convallis a eu erat. Maecenas sollicitudin magna a convallis mollis. Pellentesque pellentesque sapien et nibh molestie molestie. Curabitur in ligula a mauris consequat placerat. Praesent sit amet lacus sed eros molestie varius.",
        "Quisque porttitor magna a tortor finibus blandit facilisis tempus odio. Praesent id convallis elit, sed efficitur arcu. Pellentesque sollicitudin nisl felis, ac fermentum sapien finibus sit amet. Sed lacinia, enim ac bibendum scelerisque, lectus ex efficitur tortor, vel blandit lorem ante a erat. Cras sit amet placerat ipsum. In tempus dignissim arcu. Nam at nunc eu ante volutpat aliquet at lacinia nibh. Vestibulum ultricies condimentum nunc non consequat. Proin iaculis elit at ex lacinia, quis mattis velit commodo. Maecenas commodo libero non turpis molestie rhoncus. Curabitur posuere neque in eros malesuada dapibus.",
        "Etiam id consequat dui. Nulla rhoncus nunc nec diam finibus, porta eleifend lectus tincidunt. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nunc ac placerat justo. Curabitur finibus, leo a viverra blandit, erat turpis porta dolor, vel facilisis est quam nec tellus. Morbi nec enim eget dui dignissim euismod. Proin fermentum diam eu felis pulvinar, vitae bibendum felis aliquam. Sed non dui et augue dictum blandit pretium in nunc. Donec in quam neque. Cras tincidunt, lacus vitae imperdiet dictum, sem risus tincidunt turpis, vel pretium lorem ipsum non arcu.",
        "Sed feugiat pellentesque nisi ut posuere. Nullam a ligula accumsan, tristique nulla a, aliquam nibh. Maecenas mauris diam, volutpat a sapien eu, congue dignissim ante. Nam vitae leo ut libero rutrum dictum ut a augue. Ut et velit ac lorem euismod auctor ut nec elit. Aenean quis ligula euismod, tincidunt ante sed, congue purus. Nulla facilisi. Maecenas finibus odio at libero lacinia accumsan.",
        "Praesent id convallis elit, blandit adipiscing arcu. Nullam blandit, ipsum nec elementum aliquam, ante sem molestie nisl, sed faucibus odio ipsum quis urna. Proin facilisis interdum turpis, vitae tincidunt est pulvinar quis. Fusce commodo semper ultrices. Nam pretium dapibus felis, nec cursus erat hendrerit non. Nulla rhoncus ullamcorper augue ut hendrerit. Phasellus quis facilisis elit. Vivamus facilisis aliquam est non tempus. Donec tincidunt leo nunc, in accumsan velit porttitor molestie. In mollis auctor pharetra. Nunc faucibus feugiat lacus eget elementum. Integer dictum libero lectus. Nunc ac convallis diam, vitae pharetra mi. Donec nec eleifend odio. Curabitur ultricies nulla nec libero scelerisque, id vehicula orci blandit. Nunc ullamcorper, quam eu blandit facilisis, arcu arcu aliquam tortor, id convallis eros massa vel erat. Proin leo purus, elementum dictum eros in, malesuada porta ante.",
    ]

    let output = "";
    let title = false;
    let regex = null;
    switch (selector) {
        case "c":
        case "char":
            regex = new RegExp(`^.{${count}}`);
            break;
        case "t":
        case "title":
            title = true;
            count = Math.floor(Math.random() * (8 - 3)) + 3; // No break!
        case "w":
        case "word":
            regex = new RegExp(`^(\\w+[,.\\s]*?){${count}}[.]?`);
            break;
        default:
        case "s":
        case "sentence":
            regex = new RegExp(`((.+?)[.!?]\\s*?){0,${count}}`);
            break;
        case "p":
        case "paragraph":
            break;
    }

    if (regex === null) {
        // Prepare paragraphs
        while (count > 0) {
            output += paragraphs[Math.floor(Math.random() * paragraphs.length)]
            count--;
            if (count > 0) output += paragraphSeparator;
        }
    } else {
        // Prepare longer string for better word and sentence selection.
        let str = "";
        while (paragraphs.length > 0) {
            str += paragraphs.splice(Math.floor(Math.random() * paragraphs.length), 1)[0];
            if (paragraphs.length > 0) str += " ";
        }

        const match = str.match(regex);
        output += match[0];

        if (title) {
            output = output.replace(/[^\w\s]/gi, ''); // Remove commas, stops and other symbols from title
        }
    }

    return output;
}

function getPlaceholderImageUrl() {
    return "/p/triangles/" + Math.floor(Math.random() * 16) + ".svg";
}

function htmlDecode(input) {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
//endregion

//region Render gallery on page based on data tags
let galleriesCache = {};
initializeGalleries();

/**
 * Will make elements with data-gallery or data-gallery-tags attribute to open gallery on click or render preview.
 */
function initializeGalleries() {
    let galleryContainers = document.querySelectorAll("[data-gallery]:not(.rendered):not([data-segment])");
    for (let i = 0, gallery; gallery = galleryContainers[i]; i++) {
        renderGallery(gallery, {
            type: 'folder-id'
        });
        gallery.classList.add('rendered'); // Mark this gallery as rendered so it won't re-render it every time
    }

    let tagGalleryContainers = document.querySelectorAll("[data-gallery-tags]:not(.rendered):not([data-segment])");
    for (let i = 0, gallery; gallery = tagGalleryContainers[i]; i++) {
        renderGallery(gallery, {
            type: 'file-tags'
        });
        gallery.classList.add('rendered');
    }
}

/**
 * Will make elements with data-gallery or data-gallery-tags attribute to open gallery on click.
 * data-gallery value must be gallery id
 * When data-preview is declared thumbnails will be rendered inside gallery container, existing data will be lost
 *
 * @param {HTMLElement} gallery This element will be turned into gallery. Contents are cleared when using preview.
 * @param {object} options
 * @param {string} options.type Supported types are 'folder-id' (data-gallery) and 'file-tags' (data-gallery-tags)
 * @param {string} options.sourceQuery Identifier which is used as a cache key and is added to the queryUrl in some cases.
 * When sourceQuery is not provided it will use data-gallery or data-gallery-tags attribute value.
 * @param {string} options.queryUrl Url from where to query images in pswp supported format.
 * @param {number} options.previewCount Default is 4. When data-preview is available it will be used as fallback.
 * -1 sets no limit. When 0, no preview is rendered - element will get click event listener to open gallery.
 * @param {boolean} options.clearCache
 */
function renderGallery(gallery, options) {
    if (typeof options === "undefined") {
        options = {
            clearCache: false,
        };
    }

    if (typeof options.type === "undefined") {
        if (typeof gallery.dataset.gallery !== "undefined" && gallery.dataset.gallery !== "") {
            options.type = "folder-id";
            options.sourceQuery = gallery.dataset.gallery;
            options.queryUrl = '/gallery/get-images-by-album?id=' + options.sourceQuery;
        } else if (typeof gallery.dataset.gallery !== "undefined" && gallery.dataset.gallery !== "") {
            options.type = "file-tags";
            options.sourceQuery = gallery.dataset.galleryTags;
            options.queryUrl = '/gallery/get-images-by-tags?tags=' + options.sourceQuery;
        } else {
            console.warn("Unknown gallery type");
            return;
        }
    }

    if (typeof options.sourceQuery === "undefined") {
        switch (options.type) {
            case "folder-id":
                options.sourceQuery = gallery.dataset.gallery;
                break;
            case "file-tags":
                options.sourceQuery = gallery.dataset.galleryTags;
                break;
            default:
                return;
        }
    }

    if (typeof options.queryUrl === "undefined") {
        switch (options.type) {
            case "folder-id":
                options.queryUrl = '/gallery/get-images-by-album?id=' + options.sourceQuery;
                break;
            case "file-tags":
                options.queryUrl = '/gallery/get-images-by-tags?tags=' + options.sourceQuery;
                break;
            default:
                return;
        }
    }

    // Clear cache when needed
    if (options.clearCache) delete galleriesCache[options.sourceQuery];

    if (typeof options.renderAfterLoad === "undefined")
        options.renderAfterLoad = false;

    // Get preview count
    if (typeof options.previewCount === "undefined") {
        if (typeof gallery.dataset.preview !== "undefined" && gallery.dataset.preview !== "") {
            options.previewCount = parseInt(gallery.dataset.preview);
        } else {
            options.previewCount = 4;
        }
    }

    let isPreview = options.previewCount !== 0 && options.previewCount !== false;
    let index = gallery.hasAttribute('data-index') ? parseInt(gallery.dataset.index) : 0;

    // Mark this gallery as rendered so it won't re-render it every time
    if (!gallery.classList.contains('rendered'))
        gallery.classList.add('rendered');

    if (isPreview) {
        if (typeof galleriesCache[options.sourceQuery] === "undefined") {
            getJSON(options.queryUrl).then(function (items) {
                galleriesCache[options.sourceQuery] = items;
                renderGalleryPreview(gallery, items, options.previewCount, options.renderAfterLoad);
            });
        } else {
            renderGalleryPreview(gallery, galleriesCache[options.sourceQuery], options.previewCount, options.renderAfterLoad);
        }
    } else {
        gallery.addEventListener('click', function () {
            if (typeof galleriesCache[options.sourceQuery] === "undefined") {
                getJSON(options.queryUrl).then(function (items) {
                    galleriesCache[options.sourceQuery] = items;
                    openGallery(items, index);
                });
            } else {
                openGallery(galleriesCache[options.sourceQuery], index);
            }
        });
    }
}

function openGallery(images, index) {
    let options = {
        index: index || 0
    };
    let pswpElement = document.querySelector('.pswp');
    let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, options);
    gallery.init();
}

/**
 * Renders gallery inside of an element. Click listener will be added to every image which will open full screen viewer.
 * @param {HTMLElement} element Content of this element is cleared and replaced with gallery. Except when already containing gallery then we update.
 * @param {Array} images Array of image objects from Gallery controller. Read more about format from PhotoSwipe doc.
 * @param {Number} imageCount Limit how many images are shown in preview.
 * @param {boolean} renderAfterLoad Waits until all images are loaded and then inserts gallery to the page. Default is false.
 */
function renderGalleryPreview(element, images, imageCount, renderAfterLoad) {
    let imageLimit = imageCount || 4;
    if (imageCount < 0) imageLimit = images.length; //-1 will show all, meaning no limit
    if (imageLimit > images.length) imageLimit = images.length;

    let container = element.querySelector('.inline-gallery');
    if (container) {
        // Update existing
        for (let i = 0, img;
            (img = container.children[i]) || i < imageLimit; i++) {
            if (img == null) {
                // Add if image doesn't exist
                let imgDom = document.createElement('div');
                imgDom.style.backgroundImage = "url('" + images[i].thumbnail + "')";
                imgDom.openGallery = openGallery.bind(null, images, i);
                imgDom.addEventListener("click", imgDom.openGallery);
                container.appendChild(imgDom);
            } else if (i >= imageLimit) {
                // Remove those which are over limit
                container.removeChild(img);
                i--;
            } else {
                // Update existing just to be sure. I could compare URLs but I'm lazy...
                if (renderAfterLoad) {
                    let downloader = document.createElement('img');
                    downloader.src = images[i].thumbnail;
                    downloader.addEventListener('load', (function (src) {
                        this.style.backgroundImage = "url('" + src + "')";
                    }).bind(img, images[i].thumbnail))
                } else {
                    img.style.backgroundImage = "url('" + images[i].thumbnail + "')";
                }
                // Don't add second listener when there is already one
                if (typeof img.openGallery === "undefined") {
                    img.openGallery = openGallery.bind(null, images, i);
                    img.addEventListener("click", img.openGallery);
                }
            }
        }
    } else {
        // Create inline gallery
        container = document.createElement('div');
        container.className = "inline-gallery";

        let totalImages = 0;
        if (!renderAfterLoad) {
            element.textContent = "";
            element.appendChild(container);
        }

        for (let i = 0; i < imageLimit; i++) {
            let image = images[i];
            let imgDom = document.createElement('div');
            imgDom.style.backgroundImage = "url('" + image.thumbnail + "')";
            imgDom.openGallery = openGallery.bind(null, images, i);
            imgDom.addEventListener("click", imgDom.openGallery);
            container.appendChild(imgDom);
            totalImages++;

            if (renderAfterLoad) {
                let img = document.createElement('img');
                img.src = image.thumbnail;
                img.addEventListener('load', function () {
                    totalImages--;
                    if (totalImages === 0) {
                        element.textContent = "";
                        element.appendChild(container);
                    }
                })
            }
        }
    }
}

/**
 * Used to clear cache created in renderGallery()
 * @param albumId
 */
function clearGalleryCacheById(albumId) {
    delete galleriesCache[albumId];
}
//endregion

//region SVG placeholders
function replaceSVGPlaceholders() {
    let svgPlaceholders = document.querySelectorAll('.svg-placeholder[data-img-src],.replace[data-img-src]');
    for (let i = 0, p;
        (p = svgPlaceholders[i]); i++) {
        downloadRealImage(p);
    }
}

function downloadRealImage(placeholderDOM, imageSource) {
    //Download the image and then change the background
    let img = new Image();
    if (typeof imageSource !== "undefined")
        img.src = imageSource;
    else
        img.src = placeholderDOM.dataset.imgSrc

    img.onload = (function (dom) {
        if (dom.tagName === "IMG")
            dom.src = this.src;
        else
            dom.style.backgroundImage = "url('" + this.src + "')";
        dom.classList.remove("svg-placeholder");
        dom.classList.remove("replace");
    }).bind(img, placeholderDOM);
}
//endregion

//region Global drag listeners
/**
 * .dropzone - activates when something is dragged into the document
 * body.img-drag - activates only when image file is dragged
 * body.drag-active - show possible drop zones to the user
 * .drag-hover -
 */
dragEnterCount = 0;
document.addEventListener("dragenter", function (e) {
    if (dragEnterCount === 0) {
        document.body.classList.add('drag-active');

        // Check for img MIME types for .img-drag
        if (typeof e.dataTransfer.items[0] !== "undefined") {
            if (e.dataTransfer.items[0].type.match(/^image/))
                document.body.classList.add('img-drag');
        }
    }
    dragEnterCount++;

    //region Find first .dropzone parent and add .drag-hover class
    let target = e.target;
    if (target != null && !(target instanceof Element))
        target = target.parentElement; // If dragging over TextNode get parent
    while (target != null && !target.classList.contains('dropzone')) {
        target = target.parentElement;
    }
    if (target != null) {
        target.classList.add('drag-hover');
        // Keep count of how many times we enter while in dragzone
        if (typeof target.__dragEnterCount === "undefined")
            target.__dragEnterCount = 0;
        target.__dragEnterCount++
    }
    //endregion
});

document.addEventListener("dragleave", function (e) {
    //region Find first .dropzone parent and remove .drag-hover class
    let target = e.target;
    if (target != null && !(target instanceof Element))
        target = target.parentElement; // If dragging over TextNode get parent
    while (target != null && !target.classList.contains('dropzone')) {
        target = target.parentElement;
    }
    if (target != null) {
        // Remove class after truly leaving from dropzone
        target.__dragEnterCount--;
        if (target.__dragEnterCount < 1)
            target.classList.remove('drag-hover');
    }
    //endregion

    dragEnterCount--;
    if (dragEnterCount < 1) {
        document.body.classList.remove('drag-active');
        document.body.classList.remove('img-drag');
    }
});

function globalDragEnd() {
    window.dragEnterCount = 0;
    document.body.classList.remove('drag-active');
    document.body.classList.remove('img-drag');
    document.querySelectorAll('.drag-hover').forEach(elem => {
        elem.classList.remove('drag-hover');
        // Clear hover internal drag counter
        if (typeof elem.__dragEnterCount !== "undefined")
            elem.__dragEnterCount = 0;
    });
}
document.addEventListener("dragend", globalDragEnd);
//endregion

function findSegmentByName(segments, name) {
    for (let i = 0, s;
        (s = segments[i]); i++) {
        if (s.name === name) return s;
    }
    let result;
    for (let i = 0, s;
        (s = segments[i]); i++) {
        result = findSegmentByName(s.children, name);
        if (typeof result !== "undefined") return result;
    }
}
/**
 * This class is used as Singleton, initialization is done in editor.js
 * Access Notifier from the window scope
 *
 * Notifier.show("message", "info");
 *
 * @return Notifier
 */
let Notifier = function() {
    let _this = this
    const rootContainer = document.getElementById("dcms-notifications");
    let icons = {
        info: "fa-info-circle",
        success: "fa-check",
        warning: "fa-exclamation-triangle",
        danger: "fa-exclamation"
    }
    const fastFadeOut = 75;//ms from CSS

    /** Shows notification to the user
     @name show
     @function
     @param {String} message
     @param {String} [context'info']
     @param {Number} [timeout=0]
     */
    this.show = function(message, context, timeout) {
        if(typeof context === 'undefined') {
            context = 'info'
        }
        if(typeof timeout === 'undefined') {
            timeout = 0
        }
        showMessage(message, context, timeout)
    }

    /** Shows successful notification to the user.
     * Default timeout is 6 seconds.
     @name showSuccess
     @function
     @param {String} message
     @param {Number} [timeout=6000]
     */
    this.showSuccess = function(message, timeout) {
        if(typeof timeout === 'undefined') {
            timeout = 6000;
        }
        showMessage(message, "success", timeout);
    }

    /** Shows warning notification to the user
     @name showWarning
     @function
     @param {String} message
     @param {Number} [timeout=0]
     */
    this.showWarning = function(message, timeout) {
        showMessage(message, "warning", timeout);
    }

    /** Shows error notification to the user
     @name showError
     @function
     @param {String} message
     @param {Number} [timeout=0]
     */
    this.showError = function(message, timeout) {
        showMessage(message, "danger", timeout);
    }

    /** Shows multiple notifications to the user
     @name showAll
     @function
     @param {Array} messages
     @param {String} [context='info']
     @param {Number} [timeout=0]
     */
    this.showAll = (function(messages, context, timeout) {
        for(let i=0, message; (message = messages[i]); i++) {
            this.show(message, context, timeout)
        }
    }).bind(this)

    function showMessage(message, context, timeout) {
        if(typeof timeout === 'undefined') {
            timeout = 0
        }
        let icon = icons[context]
        let notificationElement = document.createElement('div')
        notificationElement.className = "notification light";
        let contentElement = document.createElement('div')
        let iconContainer = document.createElement('div')
        iconContainer.className = "icon";
        let iconElement = document.createElement('i')
        iconElement.className = "far "+icon
        let messageContainer = document.createElement('div')
        messageContainer.className = "text"
        messageContainer.innerHTML = message;
        let closeContainer = document.createElement('div')
        closeContainer.className = "notification-close-btn"
        let closeIcon = document.createElement('i')
        closeIcon.className = "far fa-times"
        
        iconContainer.appendChild(iconElement)
        closeContainer.appendChild(closeIcon)
        contentElement.appendChild(iconContainer)
        contentElement.appendChild(messageContainer)
        contentElement.appendChild(closeContainer)
        notificationElement.appendChild(contentElement)
        rootContainer.appendChild(notificationElement)

        let deleteTimer = null;
        if(timeout > 0) {
            // Animation timeout
            deleteTimer = setTimeout((function(){
                this.classList.add('exit')

                // Delete timeout
                setTimeout((function(){
                    rootContainer.removeChild(this)
                }).bind(this), fastFadeOut)
            }).bind(notificationElement), timeout)
        }

        closeContainer.addEventListener("click", (function() {
            this.classList.add('exit')

            // Clear previous timer when user closes notification
            if(deleteTimer != null) clearTimeout(deleteTimer);

            // Delete timeout for animation
            setTimeout((function(){
                rootContainer.removeChild(this)
            }).bind(this), fastFadeOut)
        }).bind(notificationElement))
    }
    
}

Notifier = new Notifier();
/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (typeof exports === 'object') {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = require('moment'); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // Copy so we don't change the dates being passed in
        var _a = new Date(a.getTime());
        var _b = new Date(b.getTime());
        setToStartOfDay(_a);
        setToStartOfDay(_b);
        return _a.getTime() === _b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {
        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        // set in `config` based on if showTime is set
        format: null,

        // an array giving the allowable input format(s).  As with moment,
        // the input formats may be either a single string or an array of strings.
        // Usually set in `config`
        inputFormats: null,

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // time
        showTime: true,
        showMinutes: true,
        showSeconds: false,
        use24hour: false,
        incrementHourBy: 1,
        incrementMinuteBy: 1,
        incrementSecondBy: 1,
        timeLabel: null,

        // option to prevent calendar from auto-closing after date is selected
        autoClose: true,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
            midnight      : 'Midnight',
            noon          : 'Noon'
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },

    renderTimePicker = function(num_options, selected_val, select_class, display_func, increment_by) {
        increment_by = increment_by || 1;
        var to_return = '<td><select class="pika-select '+select_class+'">';
        for (var i = 0; i < num_options; i += increment_by) {
            to_return += '<option value="'+i+'" '+(i==selected_val ? 'selected' : '')+'>'+display_func(i)+'</option>'
        }
        to_return += '</select></td>';
        return to_return;
    },

    renderTime = function(hh, mm, ss, opts)
    {
        var to_return = '<table cellpadding="0" cellspacing="0" class="pika-time"><tbody><tr>' +
            (opts.timeLabel !== null ? '<td class="pika-time-label">'+opts.timeLabel+'</td>' : '') +
            renderTimePicker(24, hh, 'pika-select-hour', function(i) {
                if (opts.use24hour) {
                    return i;
                } else {
                    var to_return = (i%12) + (i<12 ? ' AM' : ' PM');
                    if (to_return == '0 AM') {
                        return opts.i18n.midnight;
                    } else if (to_return == '0 PM') {
                        return opts.i18n.noon;
                    } else {
                        return to_return;
                    }
                }
            },
            opts.incrementHourBy);

        if (opts.showMinutes) {
          to_return += '<td>:</td>' +
              renderTimePicker(60, mm, 'pika-select-minute', function(i) { if (i < 10) return "0" + i; return i }, opts.incrementMinuteBy);
        }

        if (opts.showSeconds) {
            to_return += '<td>:</td>' +
                renderTimePicker(60, ss, 'pika-select-second', function(i) { if (i < 10) return "0" + i; return i }, opts.incrementSecondBy);
        }
        return to_return + '</tr></tbody></table>';
    },



    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    var newDate = new Date(
                            target.getAttribute('data-pika-year'),
                            target.getAttribute('data-pika-month'),
                            target.getAttribute('data-pika-day')
                        );
                    // Preserve time selection when date changed
                    var prevDate = self._d || opts.defaultDate;
                    if (prevDate && isDate(prevDate) && opts.showTime) {
                        newDate.setHours(prevDate.getHours());
                        newDate.setMinutes(prevDate.getMinutes());
                        if (opts.showSeconds) {
                            newDate.setSeconds(prevDate.getSeconds());
                        }
                    }
                    self.setDate(newDate);
                    if (opts.bound) {
                        sto(function() {
                            if (opts.autoClose) {
                                self.hide();
                            }
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
            else if (hasClass(target, 'pika-select-hour')) {
                self.setTime(target.value);
            }
            else if (hasClass(target, 'pika-select-minute')) {
                self.setTime(null, target.value);
            }
            else if (hasClass(target, 'pika-select-second')) {
                self.setTime(null, null, target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (opts.parse) {
                date = opts.parse(opts.field.value, opts.format || opts.inputFormats);
            } else if (hasMoment) {
                date = moment(opts.field.value, opts.inputFormats, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };


        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (opts.autoClose && !self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') ||
                    pEl === opts.trigger ||
                    (opts.showTime && hasClass(pEl, 'pika-time-container'))) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.inputFormats).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {
        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.autoClose = !!opts.autoClose;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
               this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            // If no format is given, set based on showTime
            if (opts.format === null) {
                opts.format = 'YYYY-MM-DD';
                if (opts.showTime) {
                    opts.format += ' HH:mm:ss';
                }
            }

            if(!opts.inputFormats) {
                opts.inputFormats = opts.format;
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            if (this._o.showTime) {
                return this._d.toString();
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set time components
         * Currently defaulting to setting date to today if not set
         */
        setTime: function(hours, minutes, seconds) {
            if (!this._d) {
                this._d = new Date();
                this._d.setHours(0,0,0,0);
            }
            if (hours) {
                this._d.setHours(hours);
            }
            if (minutes) {
                this._d.setMinutes(minutes);
            }
            if (seconds) {
                this._d.setSeconds(seconds);
            }
            this.setDate(this._d);
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());

            if (this._o.showTime && !this._o.showSeconds) {
                this._d.setSeconds(0);
            } else if (!this._o.showTime) {
                setToStartOfDay(this._d);
            }

            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear(),
                    hour: date.getHours(),
                    minute: date.getMinutes(),
                    second: date.getSeconds()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                if (!this._o.showTime) setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }
            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                if (!this._o.showTime) setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }
            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            if (opts.showTime) {
                var prevDate = this._d || this._o.defaultDate;
                html += '<div class="pika-time-container">' +
                        renderTime(
                            prevDate && isDate(prevDate) ? prevDate.getHours() : 0,
                            prevDate && isDate(prevDate) ? prevDate.getMinutes() : 0,
                            prevDate && isDate(prevDate) ? prevDate.getSeconds() : 0,
                            opts)
                    + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            if (!opts.showTime) setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;

            // Ensure we only compare date portion when deciding to show a date in picker
            var minDate_date = opts.minDate ? new Date(opts.minDate.getFullYear(), opts.minDate.getMonth(), opts.minDate.getDate()) : null;
            var maxDate_date = opts.maxDate ? new Date(opts.maxDate.getFullYear(), opts.maxDate.getMonth(), opts.maxDate.getDate()) : null;

            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (minDate_date && day < minDate_date) ||
                                 (maxDate_date && day > maxDate_date) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
}));

class TokenList {
    constructor(str) {
        this.list = [];
        this.parse(str);
    }

    parse(str) {
        if (typeof str === 'string') {
            this.list = str.split(' ');
        }
    }

    item(id) {
        return this.list[id];
    };

    contains(id) {
        return this.list.indexOf(id) !== -1;
    };

    add(id) {
        if (this.list.indexOf(id) === -1) {
            this.list.push(id);
        }
    };

    remove(id) {
        this.list = this.list.filter(function (item) {
            return item !== id;
        });
    };

    toggle(id) {
        if (!this.list.contains(id)) {
            this.list.add(id);
        } else {
            this.list.remove(id);
        }
    };

    toString() {
        return this.list.join(' ');
    };
}
/**
 * Segment - a reusable template component with built-in saving feature
 * As the word 'component' is overused, we are naming auto-saving templating components as a Segment in DuskCMS.
 * Segments are used to create an HTML layout and contain media like text and images. A Segment can be a composite of
 * each other.
 *
 * The difference in Segments and regular HTML elements is in pre-programmed behavior. You can save Segment content and
 * metadata into the database by just executing save function or allow the customer to re-order elements by dragging and
 * dropping.
 *
 * If the client doesn't need to change the page layout by himself, then there is no need to use Segments. You can just
 * write the whole page layout in JSX. But really some basic Segments like Img and RichText are very convenient.
 *
 * TODO: this example is bad, it won't save data
 * You can use HTML elements and components interchangeably with JSX:
 *   document.body.appendChild(
 *     <div className="card">
 *       <Img/>
 *       <RichText/>
 *     </div>
 *   );
 *
 * But there are some limitations when using Segments and other components interchangeably.
 * Container type egments will save only one level of children which are also Segments or have prop named
 * segmentName. 'segmentName' prop must have unique value to restore right data. E.g. segmentName="uniqueNameHere"
 * If you include segmentName then any element will be turned into AutoSegment and will be saved into the database.
 * AutoSegment child tree is recovered using local JSX file data (if available). AutoSegment children are not movable
 * and won't save data without having unique segmentName on their own.
 * Segments which children are not Segments or convertable to Segment are not saved and will disappear after the first
 * save. System will warn you about non-saved elements.
 *
 *
 * Or create quick templates without creating a new Segment subclass:
 *      TODO: this example is bad
 *   DCMS.templates.Template = function(props) { return <li><img/></li>};
 *   let layout = <DCMS.Template></DCMS.Template>;
 *
 * We are using last technique to create main layout which will contain individual pages.
 *
 * TODO: move those examples into README.md AND IM ACTUALLY NOT SURE IF IT'S A PROBLEM, WE SHOULD TEST IT, NO NEED FOR USELESS READING
 * When using segmentName prop be sure it's unique throughout all namespaces/scopes.
 * Following example might cause some problems:
 * SocialCard = function() {return (
 *     <div>
 *         <RichText tagName="h3" segmentName="title" />
 *     </div>
 * );}
 * return (
 *     <RowContainer>
 *       <Row>
 *           <RichText tagName="h1" segmentName="title" />
 *           <Img/>
 *       </Row>
 *       <Row>
 *           <SocialCard/>
 *           <SocialCard/>
 *       </Row>
 *     </div>
 *   );
 * I would recommend to add component name as a prefix to the segmentName:
 *  <RichText tagName="h3" segmentName="SocialCard-title" />
 *  <RichText tagName="h1" segmentName="PageContent-title" />
 *
 * TODO: ref/bindInto example
 *
 * TODO: this.props.styleList
 * TODO: set background image to div, kas saan Img segmenti kuidagi kasutada?
 *
 * @mixes SegmentToolkit
 */
class Segment {
    constructor(props) {
        log.log("%cSegment[constructor]: "+this.constructor.name, segmentLogCSS);
        /**
         *
         * @type {Element|null}
         */
        this.dom = null;

        this.props = {};
        if(typeof props !== "undefined" && props != null)
            this.props = props

        //TODO style jaoks on mingit sarnast klassi vaja
        this.props.classList = new TokenList(this.props.className);

        /**
         * Segment database id
         * @type {String}
         */
        this.segmentId = "";

        /**
         * @name props.segmentId
         * @type {Number}
         */
        if(typeof this.props.segmentId !== "undefined")
            this.segmentId = this.props.segmentId;

        /**
         * Root segments must have name to retrieve them after save
         * @type {String}
         */
        this.segmentName = "";

        /**
         * @name props.segmentName
         * @type {string}
         */
        if(typeof this.props.segmentName !== "undefined")
            this.segmentName = this.props.segmentName;

        if(typeof this.props.subtype !== "undefined")
            this.subtype = this.props.subtype;

        /**
         * In which way children elements are stacked in container
         * "" - not a container, "horizontal", "vertical"
         * @type {string}
         */
        this.containerDirection = "";

        /**
         * Multi-level segments can have dedicated children container which is set using JSX prop 'bindInto'.
         * If there is no dedicated container then it will be set to this.dom during Segment.render()
         * Example:
         * html() {
         *     let childrenContainer = {};
         *     const html = (
         *         <div {...this.props}>
         *             <div>some special tools container</div>
         *             <div bindInto={childContainer}>{this.props.children}</div>
         *         </div>
         *     );
         *     this.childrenContainer = childrenContainer.element;
         *     return html;
         * }
         *
         * @type {Element|null}
         */
        this.childrenContainer = null;

        /**
         * A segment which contains this one. C'mon we ain't dictionary.
         * @see Segment.parentElement
         * @type {Segment|null}
         * @private
         */
        this._parentSegment = null;

        /**
         * @name props.rootSegment Parent element is forced to null
         * @type {boolean}
         */
        /**
         * @name props.rawChildren Uses original JSX to render this element
         * @type {string} must have unique name
         */

        /**
         * Array of prop names which are excluded during serialization.
         * @type {[]}
         */
        this.excludeProps = ['segmentId','segmentName','subtype'];

        /**
         * This property is used as a cache, use this.fieldNameSuffix property
         * @type {string}
         * @private
         */
        this._fieldNameSuffix = null;

        /**
         * This is protected property, use this.fieldTarget property to retrieve target.
         * Namespace and id of the model we use to save and retrieve Field data.
         * Default is global namespace.
         * @typedef {Object} FieldTarget
         * @type {FieldTarget}
         * @protected
         */
        this._fieldTarget = null;

        /**
         * Contains fieldTarget which segment had while it was saved and is used to access Field data.
         * When populating I need to know what is the fieldTarget. But fieldTarget is not available until rendering is
         * done and _fieldTarget can't be used as it will override target even after element is getting a new parent.
         * This property is set to NULL after it's been used to fetch fields to avoid problems during save.
         * @type {FieldTarget|null}
         */
        this.lastFieldTarget = null;

        /**
         *
         * @type {object}
         * @private
         */
        this._fieldReadCache = null;

        // Extend this class with SegmentToolkit mixin when available
        if(typeof SegmentToolkit === "function") {
            SegmentToolkit.prototype.mixinConstructor.call(this);
        }
        // And also make extra "super" method for subclasses to extend their toolkits
        this.applyExtension = function() {};
        const isSubclass = this.constructor.name !== "Segment";
        const subclassExtensionName = this.constructor.name+"Toolkit";
        if(isSubclass && typeof DCMS.constructorMap[subclassExtensionName] === "function") {
            this.applyExtension = DCMS.constructorMap[subclassExtensionName].prototype.mixinConstructor;
        }

        // Warn developer when constructor is not added to the registry
        if(yiiOptions.isDebug) {
            const cn = this.constructor.name;
            if(typeof DCMS.constructorMap[cn] === "undefined")
                log.warn(`Segment '${cn}' is not registered in the constructor map.\nPlease add the following line after the '${cn}' class definition:\n%cDCMS.constructorMap['${cn}'] = ${cn};`,"color:#000;");
        }
    }

    /**
     * This function returns HTML for Segment with editor tools.
     * This is private method and should not be called out directly. You can get HTML through Segment.render() function.
     * @see html
     * @return {Element}
     */
    htmlWithTools() {
        return this.html();
    }

    /**
     * Returns minimal HTML of the Segment which is served to visitors.
     * By default it uses the same HTML as render(), but you can write custom simplified HTML here.
     *
     * This is private method and should not be used directly. You can get HTML through Segment.render() function.
     * @see DCMS.renderClean
     * @see DCMS.renderCache
     * @return {Element}
     */
    html() {
        return <div {...this.props}>{this.props.children}</div>;
    }

    /**
     * Creates Segment's HTML elements using html() or htmlWithTools()
     *
     * By running this command again it forces creation of a new copy of DOM Element.
     * Old DOM Element will lose it's reference to the Segment.
     *
     * Renderer also checks for global parameters DCMS.renderClean which in case of true returns cleanHtml for
     * the end-user and DCMS.renderCache which removes parts that shouldn't be included into cache.
     * @param {boolean} [reRender]      Will re-render existing dom. Default is false and generates new dom.
     * @param {boolean} [renderTools]   Will overwrite internal check for rendering tools
     * @return {Element}
     */
    render(reRender, renderTools) {
        if(typeof reRender === "undefined")
            reRender = false;
        if(typeof renderTools === "undefined")
            renderTools = !(DCMS.renderClean || DCMS.renderCache);

        log.log("%cSegment[render]: reRender="+reRender+" renderTools="+renderTools, segmentLogCSS);

        //region DOM debugging, do not use log methods until "this.html()" row. You can use console.log tho.
        //console.log("[Segment] segment has "+this.props.children.length+" props children");
        if(log.domDebug && this.props.children.length > 0) {
            // dom() will close this stack during this.props.children rendering using log.openStack(childrenCount,)
            //console.log("[segment] added "+this.props.children.length+" empty stacks");
            for(let i=this.props.children.length; i>0; i--)
                log.domStack.push([]); //lateChildrenStack
            //console.log("Added dom Stack for late Children %cOPEN GROUP","color:lime;");
            // In future, we may have an ability to render entire array, in that case we have to open more stacks
            // for(let i=this.props.children.length; i>0; i--)  but right now it doesnt help anything
            //if(this.props.children.length > 1)
            //    console.warn("Segment returned more than one children, you may need to enhance domStack behaviour");
        }
        //endregion
        if(reRender && this.dom != null) {
            let newDom = renderTools ? this.htmlWithTools() : this.html();
            this.dom.replaceWith(newDom);
            this.dom = newDom;
        } else {
            // Remove Segment reference from the old DOM to avoid unwanted behaviour.
            if (this.dom != null && !DCMS.renderCache) this.dom.segment = null;
            this.dom = renderTools ? this.htmlWithTools() : this.html();
        }

        if(this.childrenContainer == null) this.childrenContainer = this.dom;
        if(!DCMS.renderCache) this.dom.segment = this;
        return this.dom;
    }

    /**
     * Segments can have dedicated children container inside their own DOM structure.
     * Use this method to append HTML elements into container type Segments.
     * @param {Element|null} child
     */
    appendChild(child) {
        if(child !== null && child instanceof Element) {
            this.childrenContainer.appendChild(child);
            if(child.isSegment()) {
                child.segment._parentSegment = this;
            }
        }
    }

    /**
     * Segments can have dedicated children container inside their own DOM structure.
     * Use this method to insert HTML elements into container type Segments.
     * @param child
     * @param before
     */
    insertBefore(child, before) {
        if(child !== null && child instanceof Element) {
            this.childrenContainer.insertBefore(child, before);
            if (child.isSegment()) {
                child.segment._parentSegment = this;
            }
        }
    }

    /**
     *
     * @return {boolean}
     */
    get isContainer() {
        return this.containerDirection !== "";
    }

    /**
     * Similar to Node.parentElement but will return parentSegment's DOM Element.
     * @type {Element|null}
     */
    get parentElement() {
        if(this.parentSegment == null) return null;
        return this.parentSegment.dom;
    };

    /**
     * @return {Segment}
     */
    get parentSegment() {
        if(this.props.hasOwnProperty('rootSegment')) return null;
        if(this._parentSegment != null) return this._parentSegment;
        let pointer = this.dom;
        while(pointer != null && pointer.parentElement) {
            pointer = pointer.parentElement;
            if(pointer.isSegment()) {
                this._parentSegment = pointer.segment;
                return this._parentSegment;
            }
        }
        return null;
    }

    /**
     * Namespace and id of the model we use to save and retrieve Field data.
     * If this segment doesn't have its own _fieldTarget override defined, it will ask target from the parent.
     * Default is global namespace.
     * @return {FieldTarget}
     */
    get fieldTarget() {
        if(this._fieldTarget == null) {
            if(this.parentSegment != null) {
                return this.parentSegment.fieldTarget;
            } else {
                return {
                    content_class: "",
                    content_id: 0
                };
            }
        }
        return this._fieldTarget;
    }

    /**
     *
     * @returns {object<string>}
     */
    get fields() {
        if(this._fieldReadCache == null) {
            this._fieldReadCache = {};
            let fieldTarget;

            // If the lastFieldTarget is set, use it only on the first render.
            if(this.lastFieldTarget != null) {
                fieldTarget = this.lastFieldTarget;
                this.lastFieldTarget = null;
            } else {
                fieldTarget = this.fieldTarget;
            }

            if (fieldTarget.content_class == "app\\models\\Page" ||
                fieldTarget.content_class == "app\\models\\PageRevision") {
                this._fieldReadCache = page.fields;
            } else {
                this._fieldReadCache = yiiOptions.globalFields;
            }

            // TODO what is this _fieldMap?
            if (typeof this._fieldMap !== "undefined") {
                for (let key in this._fieldMap)
                    if (this._fieldMap.hasOwnProperty(key))
                        this._fieldReadCache[key] = this._fieldMap[key].value;
            }
        }

        return this._fieldReadCache;
    }

    /**
     * Suffix is added to every internally used Field name.
     * @return {string}
     */
    get fieldNameSuffix() {
        if(this._fieldNameSuffix == null) {
            // Find own id or parent id if used as a template
            this._fieldNameSuffix = "";
            let pointer = this;
            while(pointer != null && pointer.segmentId === "") {
                pointer = this.parentSegment;
            }
            if(pointer != null)
                this._fieldNameSuffix = "-s"+pointer.segmentId;
        }
        return this._fieldNameSuffix;
    }

    /**
     * Will create Segment instances based on JS objects
     * @param obj
     * @param [parent]
     * @return {Segment}
     */
    static populate(obj, parent) {
        log.log("%cSegment[populate]: "+obj.type+"(id="+obj.id+";name="+obj.name+")", segmentLogCSS)
        const objProps = JSON.parse(obj.props);
        objProps.segmentId = obj.id;
        objProps.fixed = obj.fixed;

        if(obj.name != null)
            objProps.segmentName = obj.name;

        if(obj.type === "PageContent" || obj.type === "AutoSegment")
            objProps.subtype = obj.subtype;

        if(typeof DCMS.constructorMap[obj.type] === "undefined") {
            log.error(`Segment '${obj.type}' is not in the constructor map.\nPlease add the following line after the '${obj.type}' class definition:\n%cDCMS.constructorMap['${obj.type}'] = ${obj.type};`,"color:#000;");
            throw new ReferenceError(`${obj.type} is not defined in DCMS.constructorMap`);
        }

        const seg = new DCMS.constructorMap[obj.type](objProps);
        seg.lastFieldTarget = {
            content_class: obj.model_class,
            content_id: obj.model_id,
        };
        //seg._parentSegment = parent || null;

        if(seg.isContainer) {
            if(seg.props.hasOwnProperty('rawChildren')) {
                seg.props.children = DCMS.rawChildrenMap[seg.props.rawChildren];
                /*DCMS.domSearchMode = DomSearchMode.ON;
                DCMS.domSearchQuery = seg.segmentName;

                obj.children.forEach(function(child) {
                    if(child.segmentName !== "")
                        DCMS.domPopulateNamedChildrenStack.push(child);
                });

                DCMS.siteLayout();

                if(DCMS.domSearchMode === DomSearchMode.FOUND) {
                    DCMS.domSearchMode = DomSearchMode.OFF;
                    return DCMS.domSearchResult;
                }
                DCMS.domSearchMode = DomSearchMode.OFF;*/
            } else {
                seg.props.children = obj.children.map(function(child) {
                    log.log("%cSegment[populate] child", segmentLogCSS, child.name)
                    // Container children can't have segmentName, ignore those here. E: Actually it won't cause problems.
                    //if(child.name !== null && child.name.length > 0) return;
                    return Segment.populate(child, seg);
                });
            }
        } else {
            // TODO: we need to test anonymous functions here
            //console.log("populate non container children", this, seg, seg.constructor.name);
            if(seg instanceof AutoSegment) {
                // Restore AutoSegment referenced through a function
                if(seg.subtype.indexOf('function:') !== -1) {
                    const type = seg.subtype.substring(9);

                    obj.children.forEach(function(child) {
                        if(child.name !== "")
                            DCMS.domPopulateNamedChildrenStack.push(child);
                    });

                    return window[type]();
                }


                /*
                DCMS.domSearchMode = DomSearchMode.ON;
                DCMS.domSearchQuery = seg.constructor.name;

                obj.children.forEach(function(child) {
                    if(child.segmentName !== "")
                        DCMS.domPopulateNamedChildrenStack.push(child);
                });

                seg.render();

                if(DCMS.domSearchMode === DomSearchMode.FOUND) {
                    DCMS.domSearchMode = DomSearchMode.OFF;
                    return DCMS.domSearchResult;
                }
                DCMS.domSearchMode = DomSearchMode.OFF;

                // return maybe?*/

            } else if(seg instanceof Segment) {
                // I add our named children to internalSegment stack and seg.render() will use them later
                // Should I clear the domPopulateNamedChildrenStack after seg.render() so it will run faster when there
                // are a lot of deleted/unused named segments?
                obj.children.forEach(function(child) {
                    if(child.name !== "")
                        DCMS.domPopulateNamedChildrenStack.push(child);
                });

            }
        }

        const element = seg.render();

        // Clean unused segments from the list or otherwise they might be used to populate some children elsewhere.
        obj.children.forEach(function(child) {
            if (child.name !== "") {
                const index = DCMS.domPopulateNamedChildrenStack.indexOf(child);
                if(index !== -1) DCMS.domPopulateNamedChildrenStack.splice(index, 1);
            }
        });

        return element;
    }
}
DCMS.constructorMap['Segment'] = Segment;

/*
 * I'm extending Element prototype with segment functionality.
 * We will get warned through console when standards have been changed and keywords are conflicting.
 */
if('isSegment' in Element.prototype) console.warn("Element.prototype.isSegment already exists! Refactor is needed.");
if('segment' in Element.prototype) console.warn("Element.prototype.segment already exists! Refactor is needed.");
/**
 * @name Element#segment
 * @type {Segment|SegmentToolkit}  Contains Segment which created this Element. May be undefined, check using element.isSegment()
 */
/**
 * Is Element created by Segment
 * @returns {boolean}
 */
Element.prototype.isSegment = function () {
    return typeof this.segment !== "undefined" && this.segment instanceof Segment;
}
/**
 * Regular HTML elements which have segmentName prop will be turned into Segment automatically.
 * AutoSegment will render right template when populating existing layout.
 */
class AutoSegment extends Segment {
    constructor(props) {
        super(props);

        this.applyExtension();
    }

    static createFromElement(element, parent) {
        let props = {};
        if(element.isSegment()) {
            props = element.segment.dom._creationProps;
            props.subtype = element.segment.dom._creationMethod +":"+ element.segment.dom._creationName;
        } else {
            if(typeof element._creationProps !== "undefined") {
                props = element._creationProps;
                props.subtype = element._creationMethod +":"+ element._creationName;
            }
        }
        console.log(props);

        const seg = new AutoSegment(props);
        seg.dom = element;
        seg.childrenContainer = element;
        seg._parentSegment = parent;
        element.segment = seg;
        return seg;
    }
}
DCMS.constructorMap['AutoSegment'] = AutoSegment;
/**
 *
 */
class Grid extends Segment {
    constructor(props) {
        super(props);

        this.props.classList.add("grid-container");

        //region Container folding direction
        this.containerDirection = "horizontal";
        if(this.props.direction)
            this.containerDirection = this.props.direction;
        if(this.containerDirection === "horizontal")
            this.props.classList.add("gc-horizontal");
        else
            this.props.classList.add("gc-vertical");
        //endregion
    }

    html() {
        console.log("Grid HTML");
        return <div {...this.props}>{this.props.children}</div>;
    }
}
DCMS.constructorMap['Grid'] = Grid;
/**
 * TODO: translate strings
 */
class ImageGrid extends Grid {
    constructor(props) {
        super(props);

        this.extraData.previewCount = 4;
        if(typeof this.dataset.preview !== "undefined" && this.dataset.preview !== "") {
            this.extraData.previewCount = parseInt(this.dataset.preview);
        }

        this.extraData.sourceType = "placeholders";
        this.extraData.sourceQuery = "";
        if(typeof this.dataset.gallery !== "undefined") {
            this.extraData.sourceType = "folder-id";
            this.extraData.sourceQuery = this.dataset.gallery;
        } else if(typeof this.dataset.galleryTags !== "undefined") {
            this.extraData.sourceType = "file-tags";
            this.extraData.sourceQuery = this.dataset.galleryTags;
        }
    }

    afterLoad() {
        renderGallery(this, {
            type: this.extraData.sourceType,
            sourceQuery: this.extraData.sourceQuery,
            previewCount: this.extraData.previewCount,
            renderAfterLoad: true,
        });
    }

    onSourceTypeChange(e) {
        if(typeof e === "object") {
            this.extraData.sourceType = e.srcElement.options[e.srcElement.selectedIndex].value;
        } else {
            this.extraData.sourceType = e;
        }

        switch(this.extraData.sourceType) {
            case "folder-id":
                this.tools.albumOptions.selectedSourceLabel.textContent = "Selected folder: none"; //TODO show folder name + id
                this.tools.albumOptions.selectedSourceLabel.style.display = "block";
                this.tools.albumOptions.changeFolderBtn.style.display = "block";
                break
            default:
                this.tools.albumOptions.selectedSourceLabel.style.display = "none";
                this.tools.albumOptions.changeFolderBtn.style.display = "none";
        }
        /*renderGallery(this, {
            type: this.extraData.sourceType,
            sourceQuery: this.extraData.sourceQuery,
            previewCount: this.extraData.previewCount,
        });*/
    }

    onSourceChange(e) {
        DCMS.finder.open({
            selectionType: 'folder',
            limitSelectionToOne: true,
            selectionCallback: (function(selectedFolder) {
                this.extraData.sourceQuery = selectedFolder.id;
                console.log(selectedFolder);
                renderGallery(this, {
                    type: this.extraData.sourceType,
                    sourceQuery: this.extraData.sourceQuery,
                    previewCount: this.extraData.previewCount,
                });
            }).bind(this)
        });
    }

    /**
     * Returns DOMElement containing tools
     */
    getTools() {
        this.tools = super.getTools();

        let albumOptions = document.createElement('div');
        albumOptions.className = "options";

        //region Source selector
        let sourceLabel = document.createElement('label');
        sourceLabel.textContent = "Image source";
        albumOptions.appendChild(sourceLabel);
        let sourceSelector = createSelectElement([
            {name: "Select source", value: 'placeholders'},
            {name: "Folder", value: 'folder-id'},
            {name: "File tags", value: 'file-tags'},
            //{name: "Custom query", value: 'custom-query'},
        ]);
        sourceSelector.value = this.extraData.sourceType;
        sourceSelector.addEventListener('change', this.onSourceTypeChange.bind(this));
        albumOptions.appendChild(sourceSelector);

        let selectedSourceLabel = document.createElement('label');
        albumOptions.selectedSourceLabel = selectedSourceLabel;
        albumOptions.appendChild(selectedSourceLabel);

        let changeFolderBtn = document.createElement('button');
        changeFolderBtn.textContent = "Change folder";
        changeFolderBtn.addEventListener('click', this.onSourceChange.bind(this))
        albumOptions.changeFolderBtn = changeFolderBtn;
        albumOptions.appendChild(changeFolderBtn);

        switch(this.extraData.sourceType) {
            case "folder-id":
                selectedSourceLabel.textContent = "Selected folder: none";
                selectedSourceLabel.style.display = "block";
                changeFolderBtn.style.display = "block";
                break;
            default:
                changeFolderBtn.style.display = "none";
        }
        //endregion

        //region Preview count
        let previewCountLabel = document.createElement('label');
        previewCountLabel.textContent = "Preview image limit";
        albumOptions.appendChild(previewCountLabel);

        let previewCountInput = document.createElement('input');
        previewCountInput.type = "number";
        previewCountInput.value = this.extraData.previewCount;
        previewCountInput.addEventListener('change', e => {
            this.extraData.previewCount = e.srcElement.value;
            renderGallery(this, {
                type: this.extraData.sourceType,
                sourceQuery: this.extraData.sourceQuery,
                previewCount: this.extraData.previewCount,
            });
        })
        albumOptions.appendChild(previewCountInput);
        //endregion

        this.tools.albumOptions = albumOptions;
        return this.tools;
    }

    /**
     * @inheritDoc
     */
    beforeSave() {
        super.beforeSave();
        this.classList.remove('rendered');
    }

    /**
     * @inheritDoc
     */
    get cleanHtml() {
        // I save those extraData fields directly into HTML source to keep gallery backward compatible with older projects.
        // Also I don't know any good idea to pass extraData back to the client side. Maybe pass it as an obj through JS?
        let staticAttributes = "";
        switch(this.extraData.sourceType) {
            case "folder-id":
                staticAttributes = "data-gallery='"+this.extraData.sourceQuery+"'";
                break;
            case "file-tags":
                staticAttributes = "data-gallery-tags='"+this.extraData.sourceQuery+"'";
                break;
        }
        staticAttributes += " data-preview='"+this.extraData.previewCount+"'";
        return '<{tagname} {attributes} '+staticAttributes+'>{inner}</{tagname}>';
    }
}
DCMS.constructorMap['ImgageGrid'] = ImageGrid;
/**
 * Helper to manage file uploads.
 *
 * This class has Event listener implementation, you can use addEventListener and removeEventListener on instance.
 * Eg uploaderInstance.addEventListener('uploadCompleted', (e) => {});
 * There are 6 event callbacks:
 *  fileUploaded - when a single file has reached 100% of bytes transferred
 *  fileProcessed - when success response for a single file have arrived from the server and the file is ready to use
 *  fileFailed - when error occurred for a single file during a upload or before upload during validation
 *  uploadStarted - when upload is initiated by Event passed into startUpload method
 *  uploadProgress - file transfer progress update for every file individually
 *  uploadCompleted - when all files are processed or failed
 *  uploadFailed - when any prerequisite fails, like input had too many files. It never occurs when upload is started.
 *
 * Event fileProcessed will pass File model.
 *
 * @param {{}} options
 * @param {Number} options.fileUploadLimit - default comes from server: min(post_size, file_size). Limit is per file.
 * @param {Number|string|null} options.folderId - Folder id where to upload files, default is set by yiiOptions.uploadFolder
 * @param {boolean} options.multipleFiles - allow to upload multiple files, default is true.
 * @param {boolean} options.onlyImages - limits upload file format to images, default false. Overrides acceptMIME.
 * @param {RegExp} options.acceptMIME - compares browser detected MIME type with regex. Default is .*
 * @param {string} options.acceptExtensions - NOT IMPLEMENTED!
 * @param {boolean} options.showNotifications - uses Notifier to show success and error messages to the user. Default is true.
 * @param {boolean} options.showProgressInNotification - NOT IMPLEMENTED! Uses Notifier to show upload progress to the user. Default is false.
 * @constructor
 */
function FileUploader(options) {
    this.fileUploadLimit = yiiOptions.phpUploadLimit;
    this.folderId = yiiOptions.uploadFolder.id || null;
    this.multipleFiles = true;
    this.onlyImages = false;
    this.acceptMIME = /.*/;
    this.acceptExtensions = "";
    this.showNotifications = true;
    this.showProgressInNotification = false;

    //Overwrite defaults with user input
    for(let name in options) {
        if(options.hasOwnProperty(name)) {
            this[name] = options[name];
        }
    }

    if(this.onlyImages)
        this.acceptMIME = /image\/.*$/;

    this.uploadInProgress = false;

    this.fileCount = 0;
    this.successCount = 0;
    this.failedCount = 0;
    this.completedCount = 0;
    this.totalProgress = [];

    this.validatedFiles = []; // List of files which are uploaded, filled in startUpload()
    this.httpClients = []; // Keep track of connections as we may want to cancel them

    //region Event listener implementation
    this.events = {};

    this.addEventListener = function(name, handler) {
        if (this.events.hasOwnProperty(name))
            this.events[name].push(handler);
        else
            this.events[name] = [handler];
    };

    this.removeEventListener = function(name, handler) {
        /* This is a bit tricky, because how would you identify functions?
           This simple solution should work if you pass THE SAME handler. */
        if (!this.events.hasOwnProperty(name))
            return;

        let index = this.events[name].indexOf(handler);
        if (index !== -1)
            this.events[name].splice(index, 1);
    };

    this.fireEvent = function(name, args) {
        if (!this.events.hasOwnProperty(name))
            return;

        if (!args || !args.length)
            args = [];

        let evs = this.events[name], l = evs.length;
        for (let i = 0; i < l; i++) {
            evs[i].apply(null, args);
        }
    };
    //endregion

    /**
     * Takes browser input change Event as an argument, so it is attachable to event listener.
     * Eg button.addEventListener('drop', uploaderInstance.startUpload);
     * @type {Function}
     * @param {Event}
     */
    this.startUpload = (function(e) {
        e = e || event;
        e.preventDefault();

        // Find files from Event
        let inputFiles;
        if(typeof e.target.files !== "undefined") {
            inputFiles = e.target.files;
        } else if(typeof e.dataTransfer.files !== "undefined") {
            inputFiles = e.dataTransfer.files;
        } else {
            const warning = "FileUploader: no files detected from event. See debug message for more information.";
            console.warn(warning);
            console.debug(e);
            const message = translate("atLeastFiles", {limit: 1});
            this.fireEvent("uploadFailed", [{message: warning, originalEvent: e}]);
            if(this.showNotifications)
                Notifier.showWarning(message);
            return;
        }

        if(!this.multipleFiles && inputFiles.length > 1) {
            const message = translate("tooManyFiles", {limit: 1});
            this.fireEvent("uploadFailed", [{message: message}]);
            if(this.showNotifications)
                Notifier.showWarning(message);
            return;
        }

        // Validate files
        this.validatedFiles = []
        for (let i=0, file; (file = inputFiles[i]); i++) {
            let failed = false;
            if(file.size >= this.fileUploadLimit) {
                const formattedLimit = humanFileSize(this.fileUploadLimit, true);
                const message = translate("uploadFileTooLarge", {file: file.name, formattedLimit: formattedLimit});
                this.fireEvent("fileFailed", [{file: file, message: message, uploadLimit: this.fileUploadLimit, uploadLimitReadable: formattedLimit}]);

                if(this.showNotifications)
                    Notifier.showError(message);
                failed = true;
            }
            if(!file.type.match(this.acceptMIME)) {
                let message = "";
                if(this.onlyImages)
                    message = translate("unsupportedFileImage", {file: file.name})+"<br>";
                message += translate("unsupportedFileType", {mimeTypes: this.acceptMIME});
                this.fireEvent("fileFailed", [{file: file, message: message}]);

                if(this.showNotifications)
                    Notifier.showError(message);
                failed = true;
            }

            if(!failed)
                this.validatedFiles.push(file);
        }

        // Reset file counters
        this.fileCount = this.validatedFiles.length;
        this.successCount = 0;
        this.failedCount = 0;
        this.completedCount = 0;
        this.totalProgress = [];

        if(this.fileCount === 0) {
            const message = translate("atLeastFiles", {limit: 1});
            this.fireEvent("uploadFailed", [{message: message}]);
            if(this.showNotifications)
                Notifier.showWarning(message);
            return;
        }

        this.uploadInProgress = true;
        this.fireEvent("uploadStarted", [{validatedFiles: this.validatedFiles}]);

        // Create an HTTP POST request for every file
        for (let i=0, file; (file = this.validatedFiles[i]); i++) {
            let formData = new FormData();
            formData.append('File[folder_id]', this.folderId);
            formData.append('File[uploadFile]', file);
            formData.append(yii.getCsrfParam(), yii.getCsrfToken());

            let xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (function (fileIndex, e) {
                // Single file progress
                const progress = e.loaded/e.total;

                // All files progress
                this.totalProgress[fileIndex] = progress;
                let globalProgress = this.totalProgress.reduce((total, p) => {return total+p;});
                globalProgress /= this.fileCount;

                // Progress event
                if(progress > 0.99 && typeof this.validatedFiles[fileIndex].finishCallbackFired === "undefined") {
                    this.fireEvent("uploadProgress", [{originalEvent: e, progress: progress, file: this.validatedFiles[fileIndex], fileIndex: fileIndex, globalProgress: globalProgress}]);
                    this.fireEvent("fileUploaded", [{originalEvent: e, progress: progress, file: this.validatedFiles[fileIndex], fileIndex: fileIndex, globalProgress: globalProgress}]);
                    this.validatedFiles[fileIndex].finishCallbackFired = true;
                } else {
                    this.fireEvent("uploadProgress", [{originalEvent: e, progress: progress, file: this.validatedFiles[fileIndex], fileIndex: fileIndex, globalProgress: globalProgress}]);
                }
            }).bind(this, i));

            xhr.addEventListener("loadend", (function(e) {
                this.httpClients.splice(i, 1); // Remove xhr from clients list as the connection is closed by now
                this.completedCount++;

                const response = JSON.parse(e.target.responseText);
                if(response.status === 'success') {
                    this.successCount++;
                    // TODO? turn response JS object into File model
                    this.fireEvent("fileProcessed", [{originalEvent: e, file: response.model}]);
                } else {
                    let message = "";
                    if(typeof response.errors !== "undefined" && response.errors.length !== 0) {
                        for(let f=0, error; (error = response.errors[f]); f++) {
                            if(this.showNotifications) Notifier.showError(error);
                            message += error+"<br>";
                        }
                    } else {
                        if(this.showNotifications)Notifier.showError(yiiOptions.strings.uploadFailed);
                        message = yiiOptions.strings.uploadFailed;
                    }

                    this.failedCount++;
                    this.fireEvent("fileFailed", [{originalEvent: e, message: message, errors: response.errors}]);
                }

                if (this.completedCount === this.fileCount) {
                    this.uploadInProgress = false;
                    this.fireEvent("uploadCompleted", [{originalEvent: e}]);

                    if(this.showNotifications)
                        Notifier.showSuccess(yiiOptions.strings.uploadCompleted);
                }
            }).bind(this));

            xhr.open("POST", "/file/create?ajax=true");
            xhr.send(formData);
            this.httpClients.push(xhr);
        }
    }).bind(this);

    this.cancelUploads = (function() {
        this.httpClients.forEach(xhr => xhr.abort());
        this.httpClients = [];
        this.uploadInProgress = false;
    }).bind(this);
}


/**
 * TODO: fix div type
 * TODO: set thumbnail size, auto thumbnail by calculatedStyle
 *
 * Usage example: <Image className="contact-card-img" src="pilt.png" asDiv/>
 * @mixes ImgToolkit
 */
class Img extends Segment {
    constructor(props) {
        super(props);
        log.debug("%cImg[constructor]", segmentLogCSS);

        /**
         * Renders image as a background on div instead of HTMLImageElement. This is untested feature.
         * @name props.asDiv
         */

        /**
         * Used in rendering. After file change this will be replaced with SVG placeholder for HTML cache.
         * @name props.src
         * @type {String}
         */
        if(typeof this.props.src === "undefined")
            this.props.src = getPlaceholderImageUrl();

        /**
         * File model id
         * @name props.fileId
         * @type {String}
         */
        if(typeof this.props.fileId === "undefined")
            this.props.fileId = null;

        /**
         * Url to current src file
         * @name props.fileUrl
         * @type {String}
         */
        if(typeof this.props.fileUrl === "undefined")
            this.props.fileUrl = null;

        if(this.props.fileUrl != null)
            this.props.src = this.props.fileUrl;

        /**
         * Inline image is containing small inline SVG to get some visuals within First Meaningful Paint.
         * @name props.inlineImage
         * @type {String}
         */
        if(typeof this.props.inlineImage === "undefined")
            this.props.inlineImage = null;

        if(this.props.hasOwnProperty('asDiv'))
            this.props.classList.add("bg-img");

        this.applyExtension();
    }

    imageHtml() {
        if(this.props.hasOwnProperty('asDiv')) {
            // Render image as a background of a div
            this.props.style += "url('"+this.props.src+"')"; // TODO seda võib topelt tulla, style ja class tuleks teisiti kohelda kuidagi, arrayna
            //TODO props.width ja props.height
            return <div {...this.props}></div>;
        }
        if(typeof this.props.alt === "undefined") this.props.alt = "";
        return <div className="img-wrap"><img {...this.props}/></div>;
    }

    html() {
        return this.imageHtml();
    }
}
DCMS.constructorMap['Img'] = Img;
class PageContent extends Segment {
    constructor(props) {
        super(props);

        if(typeof page !== "object") {
            throw "PageContent segment can't be used on non-page resources.";
        }

        // Prepare Field auto-save for children segments
        this._fieldTarget = {
            content_class: page.content_class,
            content_id: page.content_id
        }

        this.containerDirection = "vertical";
    }

    html() {
        // Render children when PageContent is populated with segments from database
        if(typeof this.props.children === "undefined" || this.props.children.length === 0) {

            // If we have page layout in templates use it to render page content
            if (typeof DCMS.templates[page.layout] !== "undefined") {
                const pageLayout = DCMS.templates[page.layout]();
                if(!pageLayout.isSegment()) {
                    const msg = "Page layout '"+page.layout+"' root element is not a Segment.";
                    Notifier.showError(msg);
                    throw msg;
                }

                // Prepare Field auto-save for children segments
                pageLayout.segment._fieldTarget = {
                    content_class: page.content_class,
                    content_id: page.content_id
                }

                this.props.subtype = pageLayout.segment.constructor.name;

                return pageLayout;
            } else {
                return <div>Cannot find template '{page.layout}'</div>;
            }
        }

        delete this.props.segmentName;
        return dom(DCMS.constructorMap[this.props.subtype], this.props, this.props.children);
    }
}
DCMS.constructorMap['PageContent'] = PageContent;
/**
 *
 */
class RichText extends Segment {
    constructor(props) {
        super(props);

        this.fieldName = "";
        if(this.segmentId !== "") {
            this.fieldName = "content-"+this.segmentId;
        }

        this.tagName = "div";
        if(this.props.hasOwnProperty('tagName')) {
            this.tagName = this.props.tagName
            if(this.tagName !== "div") {
                this.props.dataFixture = "";
                delete this.props.dataEditable
            }
        }

        this.applyExtension();
    }

    get field() {
        if(this.fieldName !== "" && typeof this.fields[this.fieldName] !== "undefined")
            return this.fields[this.fieldName];
        if(typeof this.props.children !== "undefined" && this.props.children.length !== 0) {
            // Wrap raw text nodes into paragraph when data-editable (we need it due ContentTools limitation)
            if(this.props.hasOwnProperty('dataEditable')) {
                for(let i=0, child; (child = this.props.children[i]); i++) {
                    if(child instanceof Text) {
                        this.props.children[i] = dom('p', null, child);
                    }
                }
            }
            return this.props.children;
        }


        return this.placeholderData();
    }

    placeholderData() {
        return null;
    }

    html() {
        return dom(this.tagName, this.props, this.field);
    }
}
DCMS.constructorMap['RichText'] = RichText;
/**
 *
 */
class Row extends Segment {
    constructor(props) {
        super(props);

        /**
         * @inheritdoc
         */
        this.containerDirection = "vertical";

        this.props.classList.add('row-segment');
    }

    html() {
        return <section {...this.props}>{this.props.children}</section>;
    }
}
DCMS.constructorMap['Row'] = Row;
/**
 *
 */
class RowContainer extends Segment {
    constructor(props) {
        super(props);

        /**
         * @inheritdoc
         */
        this.containerDirection = "vertical";

        //if(this.props.hasOwnProperty())
    }

    html() {
        return <article {...this.props}>{this.props.children}</article>;
    }
}
DCMS.constructorMap['RowContainer'] = RowContainer;

/**
 * @pagelayout blog
 * @return {HTMLElement}
 */
DCMS.templates.blog = function () {
  const postContainer = {};
  const newPost = {};

  // getjson localhost 6, live 2
  getJSON("/page/get-by-category/2").then(function (posts) {

    let firstPost = posts.splice(0, 1)[0];
    //img data
    let segImg = findSegmentByName(firstPost.content.segments, 'header-img');
    let props = JSON.parse(segImg.props);
    let imgSrc = props.src
    //title data
    let segTitle = findSegmentByName(firstPost.content.segments, 'title');
    let segTitleValue = firstPost.content.fields["content-" + segTitle.id]
    //content data
    let segContent = findSegmentByName(firstPost.content.segments, 'content');
    let segContentValue = firstPost.content.fields["content-" + segContent.id]
    postContainer.element.innerHTML = "";
    postContainer.element.appendChild(
      <Row
        className="post-card new-post"
        bindInto={newPost}
        onClick={() => {
          window.location.href = makeUrl(firstPost);
        }}
      >
        <div>
          <div className="img-wrap">
            <img src={imgSrc}></img>

          </div>
          <h1 className="title">{segTitleValue}</h1>
          <p className="description">{segContentValue}</p>
          <div className="expand">
            <a href={makeUrl(firstPost)}>Loe edasi...</a>
          </div>
        </div>
      </Row>
    );

    postContainer.element.appendChild(
      <Row>
        <Grid className="blog-preview-grid gc-fill">
          {posts.map(post => {
            //img data
            let segImg = findSegmentByName(post.content.segments, 'header-img');
            let props = JSON.parse(segImg.props);
            console.log(JSON.parse(segImg.props), "segimgprops")
            let imgSrc = props.src
            console.log(imgSrc, "imgSrc")
            //title data
            let segTitle = findSegmentByName(post.content.segments, 'title');
            let segTitleValue = post.content.fields["content-" + segTitle.id]
            console.log(segTitleValue, "segTitleValue")

            //content data
            let segContent = findSegmentByName(post.content.segments, 'content');
            let segContentValue = post.content.fields["content-" + segContent.id]
            const postUrl = makeUrl(post)
            return (

              <div className="blog-post-preview" onClick={() => {
                window.location.href = postUrl
              }}>
                <div className="img-wrap">
                  <img src={imgSrc}></img>

                </div>
                <div className="desc">
                  <h3 className="title" dataFixture>
                    {segTitleValue}
                  </h3>
                  <div className="description">
                    <p>{segContentValue}</p>
                  </div>
                  <a href={postUrl} className="text-overlay">
                    <span>Loe edasi</span>
                  </a>
                </div>
              </div>
            );
          })}
        </Grid>
      </Row>
    );
  });
  function makeUrl(post) {
    return post.id && post.slug ? ("/page/" + post.id + "/" + post.slug) : ("/page/" + post.id);
  }
  return (
    <RowContainer
      className=" blog blog-feed"
      bindInto={postContainer}
    />
  );
};

/**
 * @pagelayout blogPost
 * @return {HTMLElement}
 */
DCMS.templates.blogPost = function () {
  return (
    <RowContainer>
      <Row className="blog-post">
        <Img segmentName="header-img" />
        <RichText segmentName="title" tagName="h1" className="title" dataFixture>
          {getPlaceholderText("w", 2)}
        </RichText>
        <RichText segmentName="content" className="description">
          <p>{getPlaceholderText("p", 2)}</p>
        </RichText>
      </Row>
    </RowContainer>
  );
};

function BasicNav() {
  let toggleNav = {};
  let NavLink = props => {
    return (
      <li className="nav-link" role="none">
        <a
          href={props.url}
          {...props.attrs}
          aria-haspopup="false"
          aria-label={props.label}
        >
          {props.label}
        </a>
      </li>
    );
  };
  let DropMenu = props => {
    return (
      <li className="drop-toggle nav-link" role="none">
        <a
          href
          role="menuitem"
          aria-haspopup="true"
          aria-expanded="false"
          aria-label={props.label}
        >
          {props.label} <i className="fas fa-caret-down" />
        </a>
        <ul className="drop-menu" role="menu" aria-label={props.label}>
          {props.items.map(elem => {
            if (elem.visible) {
              if (
                !elem.hasOwnProperty("class") ||
                elem.class !== "app\\models\\Category"
              ) {
                return (
                  <NavLink
                    url={elem.url}
                    label={elem.label}
                    attrs={elem.linkOptions}
                  />
                );
              }
            }
          })}
        </ul>
      </li>
    );
  };
  const root = (
    <nav id="site-navigation" className="navigation navigation-basic">
      <div className="container">
        <span className="brand-logo">
          <a href="/" aria-label="Homepage" />
        </span>
        <ul
          className="nav-link-container"
          role="menubar"
          aria-label="Site navigation"
        >
          {yiiOptions.siteNav.map(elem => {
            if (elem.visible) {
              if (typeof elem === "string") return elem;
              switch (elem.class) {
                case "app\\models\\Page":
                case "app\\models\\MenuLink":
                  return (
                    <NavLink
                      url={elem.url}
                      label={elem.label}
                      attrs={elem.linkOptions}
                    />
                  );
                case "app\\models\\Category":
                  return <DropMenu items={elem.items} label={elem.label} />;
                default:
                  return <NavLink url={elem.url} label={elem.label} />;
              }
            }
          })}
        </ul>
        <div className="toggle-nav" bindInto={toggleNav}>
          <span />
        </div>
      </div>
    </nav>
  );

  //**  functional functions
  //**

  //navbar toggle on small screens
  function handleNavToggle() {
    toggleNav.element.classList.toggle("open");
    if (toggleNav.element.classList.contains("open")) {
      root.classList.add("open");
    } else {
      root.classList.remove("open");
    }
  }

  // dropdown menu show/hide
  function handleDropMenu(event) {
    let target = event.target;
    while (target != null && !target.classList.contains("drop-toggle")) {
      if (target.classList.contains("drop-menu")) {
        target = null;
      } else {
        target = target.parentElement;
      }
    }
    if (target != null) {
      event.preventDefault();
      const targetDrop = target.querySelector(".drop-menu");
      targetDrop.classList.toggle("open");
      targetDrop.previousSibling.setAttribute(
        "aria-expanded",
        targetDrop.classList.contains("open") ? "true" : "false"
      );
      [...root.querySelectorAll(".drop-menu.open")].forEach(menu => {
        if (menu !== targetDrop) {
          menu.classList.remove("open");
          menu.previousSibling.setAttribute("aria-expanded", "false");
        }
      });
    } else {
      [...root.querySelectorAll(".drop-menu.open")].forEach(menu => {
        menu.classList.remove("open");
        menu.previousSibling.setAttribute("aria-expanded", "false");
      });
    }
  }

  // Event listeners
  toggleNav.element.addEventListener("click", handleNavToggle);
  document.addEventListener("click", handleDropMenu);

  return root;
}

function BlogPostPreview(props) {

  const post = props.post;
  return (
    <div className="blog-post-preview">
      <div className="img-wrap">
        <img src={post.imgSrc}></img>

      </div>
      <div className="desc">
        <h3 className="title">{post.title}</h3>
        <h3 className="title" dataFixture>
          {post.segTitleValue}
        </h3>
        <div className="description">
          <p>{segContentValue}</p>
        </div>
        <a href={props.url} className="text-overlay">
          <span>Loe edasi</span>
        </a>
      </div>
    </div>
  );
}

class ContentList extends Segment {
  html() {
    return (
      <Row className="price-view">
        <RichText segmentName="Content-Title" className="title text-center">
          {this.props.title}
        </RichText>

        <div className="price-wrap flex">
          <div className="content-card">
            <RichText
              segmentName="Content-desc-title-1"
              tagName="h3"
              dataFixture
            >
              {"Trenni nimi"}
            </RichText>
            <div className="desc flex">
              <RichText segmentName="desc-option-1">{"Kirjeldus"}</RichText>
              <span className="price">
                <RichText segmentName="price-option-1">{"Hind"}</RichText>
              </span>
            </div>
          </div>
          <div className="content-card">
            <RichText
              segmentName="Content-desc-title-2"
              tagName="h3"
              dataFixture
            >
              {"Trenni nimi"}
            </RichText>
            <div className="desc flex">
              <RichText segmentName="desc-option-2">{"Kirjeldus"}</RichText>
              <span className="price">
                <RichText segmentName="price-option-2">{"Hind"}</RichText>
              </span>
            </div>
          </div>
             <div className="content-card">
                        <RichText segmentName="Content-desc-title-3" tagName="h3" dataFixture>
                            {"Trenni nimi"}
                        </RichText>
                        <div className="desc flex">
                            <RichText segmentName="desc-option-3">{"Kirjeldus"}</RichText>
                            <span className="price"><RichText segmentName="price-option-3">{"Hind"}</RichText></span>
                        </div>
                    </div>
                    <div className="content-card">
                        <RichText segmentName="Content-desc-title-4" tagName="h3" dataFixture>
                            {"Trenni nimi"}
                        </RichText>
                        <div className="desc flex">
                            <RichText segmentName="desc-option-4">{"Kirjeldus"}</RichText>
                            <span className="price"><RichText segmentName="price-option-4">{"Hind"}</RichText></span>
                        </div>
                    </div>
        </div>
      </Row>
    );
  }
}
DCMS.constructorMap["ContentList"] = ContentList;

function FlashMessages(props) {
    let messages = [];
    if(!DCMS.renderCache) {
        for (let key in yiiOptions.flashMessages) {
            if(yiiOptions.flashMessages.hasOwnProperty(key)) {
                const message = yiiOptions.flashMessages[key];
                switch(key) {
                    case "visibility": messages.push(<li className="alert alert-info" role="alert">{message} <a href className="float-right alert-link" onClick={openSettings}>{yiiOptions.strings.changeVisibility}</a></li>); break;
                    case "success":
                    case "warning":
                    case "danger": messages.push(<li className={"alert alert-"+key} role="alert">{message}</li>); break;
                    default: messages.push(<li className="alert alert-secondary" role="alert">{message}</li>); break;
                }
            }
        }
    }
    return <ul {...props}>{messages}</ul>;
}
function Footer() {
  let FooterLink = (props) => {
    return (
      <li>
        <a
          href={props.url}
          {...props.attrs}
          aria-haspopup="false"
          aria-label={props.label}
        >
          {props.label}
        </a>
      </li>
    );
  };

  const root = (
    <footer className="footer">
      <div className="flex container">
        <Socialicons
          facebookUrl={"https://www.facebook.com/teammoisar/"}
          instagramUrl={"https://www.instagram.com/team_moisar/"}
        ></Socialicons>
        <div className="club">
          <h3>Klubist</h3>
          <ul>
            {yiiOptions.siteNav.map((elem) => {
              if (elem.visible) {
                if (typeof elem === "string") return elem;
                switch (elem.class) {
                  case "app\\models\\Page":
                  case "app\\models\\MenuLink":
                    return (
                      <FooterLink
                        url={elem.url}
                        label={elem.label}
                        attrs={elem.linkOptions}
                      />
                    );
                  case "app\\models\\Category":
                    return <DropMenu items={elem.items} label={elem.label} />;
                  default:
                    return <FooterLink url={elem.url} label={elem.label} />;
                }
              }
            })}
          </ul>
        </div>
        <div className="contact">
          <h3>Kontakt</h3>
          <div>
            {/*  <h5 className="subheading">Klubi üldmeil </h5> */}
            <ul>
              <li className="f--link">
                <a href="mailto: Info.teammoisar@gmail.com">
                  Info.teammoisar@gmail.com
                </a>
              </li>
              <li className="f--link">
                <a href="tel:+372 568 616 26" tel>
                  +372 568 616 26
                </a>
              </li>
            </ul>
          </div>
          {/*  <div>
            <h5 className="subheading">
              Baaskursuse- ja eratreener Roland Teeäär
            </h5>
            <ul>
              <li className="f--link">
                {" "}
                <a href="mailto:roland.teeaar@gmail.com">
                  roland.teeaar@gmail.com
                </a>
              </li>
              <li className="f--link">
                  <a href="tel:+372 590 854 54" tel>
                  +372 590 854 54
              </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
  return root;
}

class HeaderVideo extends Segment {
  html() {
    return (
      <header className="header video-bg-wrap">
        <div className="overlay overlay-dim"></div>
        <div className="wrap">
          <video autoplay loop id="myVideo" className="video-player">
            <source src="\video\homev.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="overlay-text overlay gc-horizontal">
          <div>
            <RichText segmentName="videotext" className="title text-white">
              {getPlaceholderText("w", 5)}
            </RichText>
            <div className="btn-inline-wrap">
              {/*  <a href="https://docs.google.com/forms/d/e/1FAIpQLSecMCQSddWRbWbb_1N1TI-8hgF5_IvCVh5u_gnpfgceBycg6Q/viewform?usp=sf_link" target="_blank" rel="noopener noreferrer" className="cta-clear btn">
                Registreeri
          </a> */}
            </div>
          </div>
        </div>
      </header>
    );
  }
}
DCMS.constructorMap["HeaderVideo"] = HeaderVideo;

function InfoSection() {
  return (
    <div className="info-section">
      <Img segmentName="infoSection-img" />
      <div className="info-text">
        <RichText segmentName="infoSection-title" tagName="h3" className="title" dataFixture>{getPlaceholderText("w", 2)}</RichText>
        <RichText segmentName="infoSection-desc" className="description"><p>{getPlaceholderText("w", 25)}</p></RichText>
      </div>
    </div>
  )
}
class SocialCard extends Segment {
  constructor(props) {
    super(props);
  }
  html() {
    return (
      <div className="social-card">
        {console.log(this.props.instagramUrl, "this.props")}
        <Img segmentName="SocialCard-img" />
        <div className="content">
          <RichText segmentName="SocialCard-title" tagName="h3" className="title" dataFixture>
            {getPlaceholderText("w", 2)}
          </RichText>
          <RichText segmentName="SocialCard-desc" className="description">
            <p>{getPlaceholderText("w", 25)}</p>
          </RichText>
          <RichText segmentName="SocialCard-price" tagName="h5" dataFixture className="price subheading">
            {"Personaaltreeningud: "}
          </RichText>
          <ul className="social-icons">
            <li title="Instagram">
              <a href={this.props.instagramUrl} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram" />
                <span>Instagram</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
DCMS.constructorMap["SocialCard"] = SocialCard;

class Socialicons extends Segment {
    html() {
        return (
            <ul className="social-icons">
                <h3>Sotsiaalmeedia </h3>
                <li title="Facebook">
                    <a href={this.props.facebookUrl} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f" />
                        <span>Facebook</span>
                    </a>
                </li>
                <li title="Instagram">
                    <a href={this.props.instagramUrl} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram" />
                        <span>Instagram</span>
                    </a>
                </li>
            </ul>
        )
    }
}
DCMS.constructorMap["Socialicons"] = Socialicons;
class TimeTable extends Segment {
  html() {
    return (
      <Row className="price-view">
        <RichText segmentName="Content-Title" className="title text-center">
          {"Tunniplaan"}
        </RichText>

        <div className="price-wrap flex">
          <div className="content-card">
            <h3>Keila Tervisekeskus</h3>
            <ul className="desc-ul">
              <span className="subheading">E:</span>
              <div className="desc">
                <p>20:00-21:00 PÕHIGRUPP</p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">T:</span>
              <div className="desc">
                <p>15:30-16:30 LASTETRENN</p>
                {/*  <p>19:00-20:00 Hiit & Boxing For Ladies </p> */}
                <p> 19:00-20:00 NAISTE TAIPOKSI TRENN </p>
                <p> 20:00-21:30 BAASKURSUS </p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">K:</span>
              <div className="desc">
                <p>20:00-21:00 PÕHIGRUPP</p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">N:</span>
              <div className="desc">
                <p>15:30-16:30 LASTETRENN</p>
                {/* <p>19:00-20:00 Hiit & Boxing For Ladies </p> */}
                <p> 19:00-20:00 NAISTE TAIPOKSI TRENN </p>
                <p> 20:00-21:30 BAASKURSUS </p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">R:</span>
              <div className="desc">
                <p>20:00-21:00 PÕHIGRUPP</p>
              </div>
            </ul>
            {/*  <ul className="desc-ul">
              <span className="subheading">L:</span>
              <div className="desc">
                <p>12:00-13:00 Lastegrupp </p>
                <p> 13:00-14:30 Baaskursus noored </p>
              </div>
            </ul> */}
          </div>
          {/* <div className="content-card">
            <h3>Tallinnas Pärnu mnt 142, Tondi Ärikeskuse sisehoov</h3>
            <ul className="desc-ul">
              <span className="subheading">E:</span>
              <div className="desc">
                <p>20:15-21:15 Hiit & Boxing For Ladies</p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">T: </span>
              <div className="desc">
                <p>20:15-21:15 UUS GRUPP - Hiit & Boxing For Ladies</p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">K:</span>
              <div className="desc">
                <p>20:15-21:15 Hiit & Boxing For Ladies</p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">N:</span>
              <div className="desc">
                <p>20:15-21:15 UUS GRUPP - Hiit & Boxing For Ladies</p>
              </div>
            </ul>
            <ul className="desc-ul">
              <span className="subheading">R:</span>
              <div className="desc">
                <p>20:15-21:15 Hiit & Boxing For Ladies</p>
              </div>
            </ul>
          </div> */}
          {/*  <a href="" className="cta-clear btn">
            Registreeri siin
          </a> */}
        </div>
      </Row>
    );
  }
}
DCMS.constructorMap["TimeTable"] = TimeTable;

/**
 * @pagelayout homepage
 * @return {HTMLElement}
 */
DCMS.templates.homepage = function () {
  return (
    <RowContainer>
      <Row className="header-wrapper">
        <HeaderVideo />
      </Row>
      <Row className="info-wrap" dName="info-wrap">
        <InfoSection segmentName="infoSection" />
      </Row>
      <Row className="info-wrap reverse" dName="info-wrap">
        <InfoSection segmentName="infoSection2" />
      </Row>
    </RowContainer>
  );
};

/**
 * @pagelayout pricing
 * @return {HTMLElement}
 */
DCMS.templates.pricing = function () {
  const title = "Hinnakiri";
  const subHeading = "Trenni nimi"
  const descLeft = "Kirjeldus";
  const descRight = "Hind";
  return (

    < RowContainer >
      <Row>

        <ContentList title={title}></ContentList>
      </Row>
    </RowContainer>
  );
};

DCMS.templates.basicSiteLayout = function() {
  return (
    <div id="site-container" className="fixed-inner navbar-fixed">
      <BasicNav />
      <main>
        <FlashMessages id="site-flash" className="container-fixed" />
        <PageContent segmentName="pageRoot" />
      </main>
      <Footer />
    </div>
  );
};

/**
 * @pagelayout timetable
 * @return {HTMLElement}
 */
DCMS.templates.timetable = function () {
    return (
        <RowContainer>
            <TimeTable></TimeTable>

        </RowContainer>
    )
}
/**
 * @pagelayout trainerInfo
 * @return {HTMLElement}
 */
DCMS.templates.trainerInfo = function () {
  return (
    <RowContainer>
      <Row>
        <RichText
          segmentName="trainer-title"
          className="title"
          tagName="h1"
          dataFixture
        >
          {"Treenerid"}
        </RichText>
        <Grid className="social-container gc-fit  gc-fixed gc-limit-2">
          <SocialCard
            instagramUrl={"https://www.instagram.com/team_moisar/"}
          ></SocialCard>
          <SocialCard instagramUrl={"https://www.instagram.com/team_moisar/"} />
          <SocialCard instagramUrl={"https://www.instagram.com/team_moisar/"} />
          <SocialCard instagramUrl={"https://www.instagram.com/team_moisar/"} />
          {/*  <SocialCard instagramUrl={"https://www.instagram.com/team_moisar/"} />
          <SocialCard instagramUrl={"https://www.instagram.com/team_moisar/"} />
          <SocialCard instagramUrl={"https://www.instagram.com/team_moisar/"} /> */}
        </Grid>
      </Row>
    </RowContainer>
  );
};


window.addEventListener("load", function () {
    window.cookieconsent.initialise(DCMS.cookieConsent);
});

window.addEventListener("DOMContentLoaded", function () {
    log.info("%cAPP[general]: DOM is ready, starting app", appLogCSS);
    // Currently we don't have client-side routing, so only pages will be rendered.
    if (DCMS.isPage) {
        renderClientSide()
        document.body.style.backgroundColor = "#111"
    };

    replaceSVGPlaceholders(); //Search for SVG placeholders and replace them with actual images

    //Upgrade checkboxes with cbox class
    [...document.querySelectorAll('input[type=checkbox].cbox')].map(upgradeCheckbox);
});

function renderClientSide() {
    // Client-side template rendering when no cache found
    if(!page.isCached) {
        log.info("%cAPP[layout]: Rendering site layout", appLogCSS);
        DCMS.siteLayout = DCMS.templates.basicSiteLayout;

        DCMS.domScanMode = true;
        DCMS.siteLayout();
        DCMS.domScanMode = false;

        DCMS.renderLayout();
    } else {
        log.info("%cAPP[layout]: Populating cached site layout", appLogCSS);
        // But even when cached we still need to show user flash messages
        document.getElementById('site-flash').replaceWith(<FlashMessages id="site-flash" className="container-fixed" />);
        //TODO: navbar ka kui oled sisse loginud kui epoe klient vms
        //  ei seda ei tule, kui oled sisse loginud pole ükski page cached
    }
}

/**
 * Renders DCMS.siteLayout and replaces #site-container content with the result.
 * @param {{}} [options]
 * @param {boolean} options.editorTools Render with or without Segment editor tools. Overwrites value in DCMS.renderClean
 * @param {boolean} options.enableEditor Executes Segment's toggleEditor function.
 */
DCMS.renderLayout = function(options) {
    if(typeof options === "object") {
        if(options.hasOwnProperty('enableEditor')) {
            toggleChildrenEditor(document.getElementById('site-container').children, options.enableEditor);
            return;
        }
        if(options.hasOwnProperty('editorTools'))
            DCMS.renderClean = !options.editorTools;
        else
            DCMS.renderClean = true;
    }
    document.getElementById('site-container').replaceWith(DCMS.siteLayout());
}

function toggleChildrenEditor(children, enable) {
    for(let i=0, c; c=children[i]; i++) {
        if(c.isSegment())
            c.segment.toggleEditor(enable);
        toggleChildrenEditor(c.children, enable);
    }
}